// This file is auto-generated by @hey-api/openapi-ts

export const AcpExportStatusSchema = {
    type: 'string',
    enum: [
        'REQUESTED',
        'PROCESSING',
        'COMPLETED',
        'ERROR'
    ],
    title: 'AcpExportStatus'
} as const;

export const AdoptionEntrySchema = {
    properties: {
        kind: {
            $ref: '#/components/schemas/ContentKind'
        },
        count: {
            type: 'integer',
            title: 'Count'
        },
        adopted: {
            items: {
                type: 'string'
            },
            type: 'array',
            title: 'Adopted'
        }
    },
    type: 'object',
    required: [
        'kind',
        'count'
    ],
    title: 'AdoptionEntry',
    description: 'One kind of Reedy-generated content the publisher adopted into this\nimport -- generated content that reappears in the imported ONIX. `adopted`\nlists all adopted items (keyword phrases or Thema codes); it is empty for\ndescriptions, which `count` alone conveys.'
} as const;

export const ChunkStatusSchema = {
    type: 'integer',
    enum: [
        100,
        200,
        300,
        400,
        500
    ],
    title: 'ChunkStatus',
    description: 'Chunk status codes for sorting and extensibility (lower = higher priority)'
} as const;

export const ContentKindSchema = {
    type: 'string',
    enum: [
        'keywords',
        'themaCodes',
        'description'
    ],
    title: 'ContentKind',
    description: 'The metadata kinds Reedy generates and an ONIX import can change or\nadopt.'
} as const;

export const EasterOffsetRuleSchema = {
    properties: {
        type: {
            type: 'string',
            const: 'easter_offset',
            title: 'Type'
        },
        date_kind: {
            $ref: '#/components/schemas/SeasonalEventDateKind'
        },
        days: {
            type: 'integer',
            maximum: 250,
            minimum: -80,
            title: 'Days'
        }
    },
    additionalProperties: false,
    type: 'object',
    required: [
        'type',
        'date_kind',
        'days'
    ],
    title: 'EasterOffsetRule'
} as const;

export const FileTypeSchema = {
    type: 'string',
    enum: [
        'ACP_EXPORT',
        'EVALUATION_REPORT',
        'MANUAL_ONIX_IMPORT',
        'MANUSCRIPT',
        'MANUSCRIPT_VERSION',
        'ONIX_CHUNK',
        'ONIX_EXPORT',
        'ONIX_IMPORT',
        'ONIX_IMPORT_REPORT',
        'TREND',
        'UNKNOWN'
    ],
    title: 'FileType'
} as const;

export const FirestoreAcpExportSchema = {
    properties: {
        id: {
            type: 'string',
            title: 'Id'
        },
        organisation: {
            $ref: '#/components/schemas/FirestoreOrganisationReference'
        },
        userId: {
            type: 'string',
            title: 'Userid'
        },
        status: {
            $ref: '#/components/schemas/AcpExportStatus',
            default: 'REQUESTED'
        },
        count: {
            anyOf: [
                {
                    type: 'integer',
                    minimum: 0
                },
                {
                    type: 'null'
                }
            ],
            title: 'Count'
        },
        storagePath: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Storagepath'
        },
        createdAt: {
            type: 'string',
            format: 'date-time',
            title: 'Createdat'
        },
        updatedAt: {
            anyOf: [
                {
                    type: 'string',
                    format: 'date-time'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Updatedat'
        }
    },
    type: 'object',
    required: [
        'id',
        'organisation',
        'userId'
    ],
    title: 'FirestoreAcpExport'
} as const;

export const FirestoreFileSchema = {
    properties: {
        updatedAt: {
            type: 'string',
            format: 'date-time',
            title: 'Updatedat'
        },
        createdAt: {
            anyOf: [
                {
                    type: 'string',
                    format: 'date-time'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Createdat'
        },
        filename: {
            type: 'string',
            title: 'Filename'
        },
        organisation: {
            $ref: '#/components/schemas/FirestoreOrganisationReference'
        },
        bucketName: {
            type: 'string',
            title: 'Bucketname'
        },
        size: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Size'
        },
        mode: {
            $ref: '#/components/schemas/FileType'
        },
        path: {
            type: 'string',
            title: 'Path'
        }
    },
    type: 'object',
    required: [
        'updatedAt',
        'createdAt',
        'filename',
        'organisation',
        'bucketName',
        'mode',
        'path'
    ],
    title: 'FirestoreFile'
} as const;

export const FirestoreGenerationRequestDescriptionsSchema = {
    properties: {
        id: {
            type: 'string',
            title: 'Id'
        },
        userId: {
            type: 'string',
            title: 'Userid'
        },
        organisation: {
            $ref: '#/components/schemas/FirestoreOrganisationReference'
        },
        entityId: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Entityid'
        },
        status: {
            $ref: '#/components/schemas/FirestoreGenerationStatus',
            default: 'REQUESTED'
        },
        statusCode: {
            anyOf: [
                {
                    $ref: '#/components/schemas/FirestoreGenerationStatusCode'
                },
                {
                    type: 'null'
                }
            ],
            default: '100'
        },
        statusMessage: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Statusmessage'
        },
        createdAt: {
            type: 'string',
            format: 'date-time',
            title: 'Createdat'
        },
        updatedAt: {
            anyOf: [
                {
                    type: 'string',
                    format: 'date-time'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Updatedat'
        },
        data: {
            $ref: '#/components/schemas/FirestoreGenerationRequestDescriptionsData'
        }
    },
    type: 'object',
    required: [
        'id',
        'userId',
        'organisation',
        'createdAt',
        'data'
    ],
    title: 'FirestoreGenerationRequestDescriptions'
} as const;

export const FirestoreGenerationRequestDescriptionsDataSchema = {
    properties: {
        hash: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Hash'
        },
        specialRequest: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Specialrequest'
        },
        targetGroup: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Targetgroup'
        }
    },
    type: 'object',
    title: 'FirestoreGenerationRequestDescriptionsData'
} as const;

export const FirestoreGenerationRequestEvaluationSchema = {
    properties: {
        id: {
            type: 'string',
            title: 'Id'
        },
        userId: {
            type: 'string',
            title: 'Userid'
        },
        organisation: {
            $ref: '#/components/schemas/FirestoreOrganisationReference'
        },
        entityId: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Entityid'
        },
        status: {
            $ref: '#/components/schemas/FirestoreGenerationStatus',
            default: 'REQUESTED'
        },
        statusCode: {
            anyOf: [
                {
                    $ref: '#/components/schemas/FirestoreGenerationStatusCode'
                },
                {
                    type: 'null'
                }
            ],
            default: '100'
        },
        statusMessage: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Statusmessage'
        },
        createdAt: {
            type: 'string',
            format: 'date-time',
            title: 'Createdat'
        },
        updatedAt: {
            anyOf: [
                {
                    type: 'string',
                    format: 'date-time'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Updatedat'
        },
        data: {
            $ref: '#/components/schemas/FirestoreGenerationRequestEvaluationData'
        }
    },
    type: 'object',
    required: [
        'id',
        'userId',
        'organisation',
        'createdAt',
        'data'
    ],
    title: 'FirestoreGenerationRequestEvaluation'
} as const;

export const FirestoreGenerationRequestEvaluationDataSchema = {
    properties: {
        mode: {
            type: 'string',
            enum: [
                'SYNC',
                'ASYNC'
            ],
            title: 'Mode',
            default: 'ASYNC'
        },
        requestedProducts: {
            anyOf: [
                {
                    type: 'string',
                    const: 'ALL'
                },
                {
                    items: {
                        type: 'string'
                    },
                    type: 'array'
                }
            ],
            title: 'Requestedproducts'
        },
        async_batch_id: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Async Batch Id'
        },
        async_batch_status: {
            anyOf: [
                {
                    $ref: '#/components/schemas/OpenAIStatus'
                },
                {
                    type: 'null'
                }
            ]
        },
        file: {
            anyOf: [
                {
                    additionalProperties: true,
                    type: 'object'
                },
                {
                    type: 'null'
                }
            ],
            title: 'File'
        },
        last_evaluated_identifier: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Last Evaluated Identifier'
        }
    },
    type: 'object',
    required: [
        'requestedProducts'
    ],
    title: 'FirestoreGenerationRequestEvaluationData'
} as const;

export const FirestoreGenerationStatusSchema = {
    type: 'string',
    enum: [
        'IMPORTED',
        'REQUESTED',
        'GENERATING',
        'GENERATED',
        'PROCESSING',
        'COMPLETED',
        'CANCELLED',
        'ERROR'
    ],
    title: 'FirestoreGenerationStatus'
} as const;

export const FirestoreGenerationStatusCodeSchema = {
    type: 'string',
    enum: [
        '100',
        '102',
        '200',
        '402',
        '422',
        '451',
        '499',
        '500'
    ],
    title: 'FirestoreGenerationStatusCode'
} as const;

export const FirestoreManuscriptProcessingReportingSchema = {
    properties: {
        id: {
            type: 'string',
            title: 'Id'
        },
        organisation: {
            $ref: '#/components/schemas/FirestoreOrganisationReference'
        },
        status: {
            $ref: '#/components/schemas/ManuscriptProcessingStatus'
        },
        fileName: {
            type: 'string',
            title: 'Filename'
        },
        isbn: {
            type: 'string',
            title: 'Isbn'
        },
        contentHash: {
            type: 'string',
            title: 'Contenthash'
        },
        objectPath: {
            type: 'string',
            title: 'Objectpath'
        },
        contentClaimed: {
            type: 'boolean',
            title: 'Contentclaimed',
            default: false
        },
        duplicateOfReportId: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Duplicateofreportid'
        },
        productId: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Productid'
        },
        productTitle: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Producttitle'
        },
        workId: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Workid'
        },
        jobId: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Jobid'
        },
        submissionTaskId: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Submissiontaskid'
        },
        semanticDataId: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Semanticdataid'
        },
        error: {
            anyOf: [
                {
                    $ref: '#/components/schemas/ManuscriptProcessingError'
                },
                {
                    type: 'null'
                }
            ]
        },
        createdAt: {
            type: 'string',
            format: 'date-time',
            title: 'Createdat'
        },
        updatedAt: {
            anyOf: [
                {
                    type: 'string',
                    format: 'date-time'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Updatedat'
        }
    },
    type: 'object',
    required: [
        'id',
        'organisation',
        'status',
        'fileName',
        'isbn',
        'contentHash',
        'objectPath'
    ],
    title: 'FirestoreManuscriptProcessingReporting',
    description: 'One entry per received manuscript version, driving the admin panel.'
} as const;

export const FirestoreOnixExportSchema = {
    properties: {
        id: {
            type: 'string',
            title: 'Id'
        },
        organisation: {
            $ref: '#/components/schemas/FirestoreOrganisationReference'
        },
        productIds: {
            items: {
                type: 'string'
            },
            type: 'array',
            title: 'Productids',
            default: []
        },
        status: {
            $ref: '#/components/schemas/OnixExportStatus',
            default: 'REQUESTED'
        },
        userId: {
            type: 'string',
            title: 'Userid'
        },
        createdAt: {
            anyOf: [
                {
                    type: 'string',
                    format: 'date-time'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Createdat'
        },
        updatedAt: {
            anyOf: [
                {
                    type: 'string',
                    format: 'date-time'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Updatedat'
        },
        fileName: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Filename'
        }
    },
    type: 'object',
    required: [
        'id',
        'organisation',
        'userId'
    ],
    title: 'FirestoreOnixExport'
} as const;

export const FirestoreOrganisationSchema = {
    properties: {
        id: {
            type: 'string',
            title: 'Id'
        },
        name: {
            type: 'string',
            title: 'Name'
        },
        parent_organisation: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Parent Organisation'
        },
        emails: {
            anyOf: [
                {
                    items: {
                        type: 'string'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Emails',
            default: []
        },
        styles: {
            anyOf: [
                {
                    items: {
                        type: 'string'
                    },
                    type: 'array'
                },
                {
                    additionalProperties: {
                        items: {
                            type: 'string'
                        },
                        type: 'array'
                    },
                    type: 'object'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Styles',
            default: []
        },
        targets: {
            anyOf: [
                {
                    items: {
                        type: 'string'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Targets',
            default: []
        },
        targetGroups: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreOrganisationTargetGroups'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Targetgroups',
            default: []
        },
        limitApiRequests: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreOrganisationLimitApiRequestsSettings'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Limitapirequests',
            default: []
        },
        limitGenerations: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreOrganisationLimitGenerationsSettings'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Limitgenerations',
            default: []
        },
        disablePromptGuard: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Disablepromptguard',
            default: false
        },
        settings: {
            $ref: '#/components/schemas/FirestoreOrganisationSettings'
        },
        descriptionsDefault: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Descriptionsdefault',
            default: 'Description'
        },
        descriptionsTypes: {
            anyOf: [
                {
                    additionalProperties: {
                        type: 'integer'
                    },
                    type: 'object'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Descriptionstypes',
            default: {}
        },
        createdAt: {
            type: 'string',
            format: 'date-time',
            title: 'Createdat'
        },
        deletedAt: {
            anyOf: [
                {
                    type: 'string',
                    format: 'date-time'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Deletedat'
        },
        hardDeletedAt: {
            anyOf: [
                {
                    type: 'string',
                    format: 'date-time'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Harddeletedat'
        }
    },
    type: 'object',
    required: [
        'id',
        'name'
    ],
    title: 'FirestoreOrganisation'
} as const;

export const FirestoreOrganisationAcpSettingsSchema = {
    properties: {
        feed_id: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Feed Id'
        },
        account_id: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Account Id'
        },
        target_merchant: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Target Merchant'
        },
        target_country: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Target Country'
        }
    },
    type: 'object',
    title: 'FirestoreOrganisationAcpSettings'
} as const;

export const FirestoreOrganisationLanguageSchema = {
    type: 'string',
    enum: [
        'en-GB',
        'en-US',
        'de-DE'
    ],
    title: 'FirestoreOrganisationLanguage'
} as const;

export const FirestoreOrganisationLimitApiRequestsSettingsSchema = {
    properties: {
        interval: {
            type: 'integer',
            title: 'Interval'
        },
        limit: {
            type: 'integer',
            title: 'Limit'
        }
    },
    type: 'object',
    required: [
        'interval',
        'limit'
    ],
    title: 'FirestoreOrganisationLimitApiRequestsSettings'
} as const;

export const FirestoreOrganisationLimitGenerationsSettingsSchema = {
    properties: {
        interval: {
            type: 'integer',
            title: 'Interval'
        },
        limit: {
            type: 'integer',
            title: 'Limit'
        }
    },
    type: 'object',
    required: [
        'interval',
        'limit'
    ],
    title: 'FirestoreOrganisationLimitGenerationsSettings'
} as const;

export const FirestoreOrganisationMarketplaceSchema = {
    type: 'string',
    enum: [
        'UK',
        'US',
        'GER',
        'AU',
        'NONE'
    ],
    title: 'FirestoreOrganisationMarketplace'
} as const;

export const FirestoreOrganisationReferenceSchema = {
    properties: {
        id: {
            type: 'string',
            title: 'Id'
        }
    },
    type: 'object',
    required: [
        'id'
    ],
    title: 'FirestoreOrganisationReference'
} as const;

export const FirestoreOrganisationSalesDataLakeSchema = {
    type: 'string',
    enum: [
        'MMDE',
        'PMUK',
        'MMUS',
        'DISABLED'
    ],
    title: 'FirestoreOrganisationSalesDataLake',
    description: 'Which sales data lake an organisation reads from.'
} as const;

export const FirestoreOrganisationSettingsSchema = {
    properties: {
        inactiveProductStatus: {
            items: {
                $ref: '#/components/schemas/PRODUCT_AVAILABILITY_CODE_LITERAL'
            },
            type: 'array',
            title: 'Inactiveproductstatus'
        },
        excludeNoAvailabilityCode: {
            type: 'boolean',
            title: 'Excludenoavailabilitycode',
            default: false
        },
        canSeeAmazonSearchTerms: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Canseeamazonsearchterms',
            default: false
        },
        marketplace: {
            anyOf: [
                {
                    $ref: '#/components/schemas/FirestoreOrganisationMarketplace'
                },
                {
                    type: 'null'
                }
            ],
            default: 'NONE'
        },
        language: {
            anyOf: [
                {
                    $ref: '#/components/schemas/FirestoreOrganisationLanguage'
                },
                {
                    type: 'null'
                }
            ],
            default: 'en-US'
        },
        acpSettings: {
            anyOf: [
                {
                    $ref: '#/components/schemas/FirestoreOrganisationAcpSettings'
                },
                {
                    type: 'null'
                }
            ]
        },
        salesDataLake: {
            $ref: '#/components/schemas/FirestoreOrganisationSalesDataLake',
            default: 'DISABLED'
        }
    },
    type: 'object',
    title: 'FirestoreOrganisationSettings'
} as const;

export const FirestoreOrganisationTargetGroupsSchema = {
    properties: {
        name: {
            type: 'string',
            title: 'Name'
        },
        description: {
            type: 'string',
            title: 'Description'
        }
    },
    type: 'object',
    required: [
        'name',
        'description'
    ],
    title: 'FirestoreOrganisationTargetGroups'
} as const;

export const FirestoreProductSchema = {
    properties: {
        id: {
            type: 'string',
            title: 'Id'
        },
        identifier: {
            type: 'string',
            title: 'Identifier'
        },
        identifierType: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Identifiertype'
        },
        identifiers: {
            items: {
                $ref: '#/components/schemas/FirestoreProductIdentifier'
            },
            type: 'array',
            title: 'Identifiers',
            default: []
        },
        workId: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Workid'
        },
        importData: {
            anyOf: [
                {
                    $ref: '#/components/schemas/FirestoreProductImportData'
                },
                {
                    type: 'null'
                }
            ]
        },
        title: {
            type: 'string',
            title: 'Title'
        },
        descriptions: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductDescription'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Descriptions',
            default: []
        },
        subtitles: {
            items: {
                $ref: '#/components/schemas/FirestoreProductSubtitleCandidate'
            },
            type: 'array',
            title: 'Subtitles',
            default: []
        },
        biography: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Biography'
        },
        author: {
            items: {
                type: 'string'
            },
            type: 'array',
            title: 'Author',
            default: []
        },
        genre: {
            items: {
                type: 'string'
            },
            type: 'array',
            title: 'Genre',
            default: []
        },
        keywordCount: {
            type: 'integer',
            title: 'Keywordcount',
            default: 0
        },
        language: {
            type: 'string',
            title: 'Language'
        },
        languageOriginal: {
            type: 'string',
            title: 'Languageoriginal'
        },
        organisation: {
            $ref: '#/components/schemas/FirestoreOrganisationReference'
        },
        productGroup: {
            $ref: '#/components/schemas/PRODUCT_FORM_CODE_LITERAL'
        },
        productGroupDescription: {
            $ref: '#/components/schemas/PRODUCT_FORM_DESC_LITERAL'
        },
        publisher: {
            type: 'string',
            title: 'Publisher'
        },
        publishers: {
            items: {
                $ref: '#/components/schemas/FirestoreProductPublisher'
            },
            type: 'array',
            title: 'Publishers',
            default: []
        },
        imprints: {
            items: {
                type: 'string'
            },
            type: 'array',
            title: 'Imprints',
            default: []
        },
        publishedAt: {
            anyOf: [
                {
                    type: 'string',
                    format: 'date-time'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Publishedat'
        },
        createdAt: {
            type: 'string',
            format: 'date-time',
            title: 'Createdat'
        },
        updatedAt: {
            type: 'string',
            format: 'date-time',
            title: 'Updatedat'
        },
        subjects: {
            anyOf: [
                {
                    $ref: '#/components/schemas/FirestoreProductSubjects'
                },
                {
                    type: 'null'
                }
            ]
        },
        forceSyncTriggeredAt: {
            anyOf: [
                {
                    type: 'string',
                    format: 'date-time'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Forcesynctriggeredat'
        },
        categorization: {
            anyOf: [
                {
                    $ref: '#/components/schemas/FirestoreProductCategorization'
                },
                {
                    type: 'null'
                }
            ],
            default: {
                fiction: true,
                nonFiction: true,
                children: true,
                updatedAt: null,
                inferredFrom: null
            }
        },
        sourceType: {
            $ref: '#/components/schemas/ProductSource',
            default: 'ONIX_IMPORT'
        },
        manuscript: {
            anyOf: [
                {
                    $ref: '#/components/schemas/FirestoreProductManuscript'
                },
                {
                    type: 'null'
                }
            ]
        },
        actions: {
            $ref: '#/components/schemas/FirestoreProductActions'
        },
        isEligibleSearch: {
            type: 'boolean',
            title: 'Iseligiblesearch',
            default: true
        },
        isEligibleCheckout: {
            type: 'boolean',
            title: 'Iseligiblecheckout',
            default: false
        },
        supplyDetails: {
            items: {
                $ref: '#/components/schemas/FirestoreProductSupplyDetail'
            },
            type: 'array',
            title: 'Supplydetails'
        },
        dimensions: {
            anyOf: [
                {
                    $ref: '#/components/schemas/FirestoreProductDimensions'
                },
                {
                    type: 'null'
                }
            ]
        },
        ageRanges: {
            anyOf: [
                {
                    $ref: '#/components/schemas/FirestoreProductAgeRanges'
                },
                {
                    type: 'null'
                }
            ]
        },
        images: {
            $ref: '#/components/schemas/FirestoreProductImages'
        },
        quotes: {
            items: {
                $ref: '#/components/schemas/FirestoreProductQuote'
            },
            type: 'array',
            title: 'Quotes',
            default: []
        },
        series: {
            $ref: '#/components/schemas/FirestoreProductSeries'
        }
    },
    type: 'object',
    required: [
        'id',
        'identifier',
        'title',
        'language',
        'languageOriginal',
        'organisation',
        'productGroup',
        'productGroupDescription',
        'publisher',
        'publishedAt',
        'createdAt',
        'updatedAt'
    ],
    title: 'FirestoreProduct'
} as const;

export const FirestoreProductActionsSchema = {
    properties: {
        active: {
            type: 'boolean',
            title: 'Active',
            default: false
        },
        errored: {
            type: 'boolean',
            title: 'Errored',
            default: false
        },
        keywords: {
            $ref: '#/components/schemas/FirestoreProductActionsKeywords'
        },
        descriptions: {
            anyOf: [
                {
                    $ref: '#/components/schemas/FirestoreProductActionsDescriptions'
                },
                {
                    type: 'null'
                }
            ]
        },
        thema: {
            anyOf: [
                {
                    $ref: '#/components/schemas/FirestoreProductActionsThema'
                },
                {
                    type: 'null'
                }
            ]
        },
        manuscript: {
            anyOf: [
                {
                    $ref: '#/components/schemas/FirestoreProductActionsManuscript'
                },
                {
                    type: 'null'
                }
            ]
        },
        subtitle: {
            anyOf: [
                {
                    $ref: '#/components/schemas/FirestoreProductActionsSubtitle'
                },
                {
                    type: 'null'
                }
            ]
        }
    },
    type: 'object',
    title: 'FirestoreProductActions'
} as const;

export const FirestoreProductActionsDescriptionsSchema = {
    properties: {
        active: {
            type: 'boolean',
            title: 'Active',
            default: false
        },
        errored: {
            type: 'boolean',
            title: 'Errored',
            default: false
        },
        actions: {
            additionalProperties: {
                $ref: '#/components/schemas/FirestoreProductActionsDescriptionsActions'
            },
            type: 'object',
            title: 'Actions'
        }
    },
    type: 'object',
    title: 'FirestoreProductActionsDescriptions'
} as const;

export const FirestoreProductActionsDescriptionsActionsSchema = {
    properties: {
        generate: {
            $ref: '#/components/schemas/FirestoreProductActionsValue'
        }
    },
    type: 'object',
    title: 'FirestoreProductActionsDescriptionsActions'
} as const;

export const FirestoreProductActionsKeywordsSchema = {
    properties: {
        active: {
            type: 'boolean',
            title: 'Active',
            default: false
        },
        errored: {
            type: 'boolean',
            title: 'Errored',
            default: false
        },
        actions: {
            $ref: '#/components/schemas/FirestoreProductActionsKeywordsActions'
        }
    },
    type: 'object',
    title: 'FirestoreProductActionsKeywords'
} as const;

export const FirestoreProductActionsKeywordsActionsSchema = {
    properties: {
        rank: {
            anyOf: [
                {
                    $ref: '#/components/schemas/FirestoreProductActionsValue'
                },
                {
                    type: 'null'
                }
            ]
        },
        generate: {
            anyOf: [
                {
                    $ref: '#/components/schemas/FirestoreProductActionsValue'
                },
                {
                    type: 'null'
                }
            ]
        },
        autoFill: {
            anyOf: [
                {
                    $ref: '#/components/schemas/FirestoreProductActionsValue'
                },
                {
                    type: 'null'
                }
            ]
        }
    },
    type: 'object',
    title: 'FirestoreProductActionsKeywordsActions'
} as const;

export const FirestoreProductActionsManuscriptSchema = {
    properties: {
        active: {
            type: 'boolean',
            title: 'Active',
            default: false
        },
        errored: {
            type: 'boolean',
            title: 'Errored',
            default: false
        },
        actions: {
            anyOf: [
                {
                    $ref: '#/components/schemas/FirestoreProductActionsManuscriptActions'
                },
                {
                    type: 'null'
                }
            ]
        }
    },
    type: 'object',
    title: 'FirestoreProductActionsManuscript'
} as const;

export const FirestoreProductActionsManuscriptActionsSchema = {
    properties: {
        analyse: {
            anyOf: [
                {
                    $ref: '#/components/schemas/FirestoreProductActionsValue'
                },
                {
                    type: 'null'
                }
            ]
        }
    },
    type: 'object',
    title: 'FirestoreProductActionsManuscriptActions'
} as const;

export const FirestoreProductActionsSubtitleSchema = {
    properties: {
        active: {
            type: 'boolean',
            title: 'Active',
            default: false
        },
        errored: {
            type: 'boolean',
            title: 'Errored',
            default: false
        },
        actions: {
            anyOf: [
                {
                    $ref: '#/components/schemas/FirestoreProductActionsSubtitleActions'
                },
                {
                    type: 'null'
                }
            ]
        }
    },
    type: 'object',
    title: 'FirestoreProductActionsSubtitle'
} as const;

export const FirestoreProductActionsSubtitleActionsSchema = {
    properties: {
        generate: {
            anyOf: [
                {
                    $ref: '#/components/schemas/FirestoreProductActionsValue'
                },
                {
                    type: 'null'
                }
            ]
        }
    },
    type: 'object',
    title: 'FirestoreProductActionsSubtitleActions'
} as const;

export const FirestoreProductActionsThemaSchema = {
    properties: {
        active: {
            type: 'boolean',
            title: 'Active',
            default: false
        },
        errored: {
            type: 'boolean',
            title: 'Errored',
            default: false
        },
        actions: {
            anyOf: [
                {
                    $ref: '#/components/schemas/FirestoreProductActionsThemaActions'
                },
                {
                    type: 'null'
                }
            ]
        }
    },
    type: 'object',
    title: 'FirestoreProductActionsThema'
} as const;

export const FirestoreProductActionsThemaActionsSchema = {
    properties: {
        generate: {
            anyOf: [
                {
                    $ref: '#/components/schemas/FirestoreProductActionsValue'
                },
                {
                    type: 'null'
                }
            ]
        }
    },
    type: 'object',
    title: 'FirestoreProductActionsThemaActions'
} as const;

export const FirestoreProductActionsValueSchema = {
    properties: {
        status: {
            anyOf: [
                {
                    $ref: '#/components/schemas/FirestoreGenerationStatus'
                },
                {
                    type: 'null'
                }
            ]
        },
        statusCode: {
            anyOf: [
                {
                    $ref: '#/components/schemas/FirestoreGenerationStatusCode'
                },
                {
                    type: 'null'
                }
            ]
        },
        msg: {
            type: 'string',
            title: 'Msg',
            default: ''
        }
    },
    type: 'object',
    title: 'FirestoreProductActionsValue'
} as const;

export const FirestoreProductAgeRangeSchema = {
    properties: {
        gte: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Gte'
        },
        lte: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Lte'
        }
    },
    type: 'object',
    title: 'FirestoreProductAgeRange',
    description: 'A normalized audience age range; either bound may be open-ended.'
} as const;

export const FirestoreProductAgeRangesSchema = {
    properties: {
        interestAgeMonths: {
            anyOf: [
                {
                    $ref: '#/components/schemas/FirestoreProductAgeRange'
                },
                {
                    type: 'null'
                }
            ]
        },
        interestAgeYears: {
            anyOf: [
                {
                    $ref: '#/components/schemas/FirestoreProductAgeRange'
                },
                {
                    type: 'null'
                }
            ]
        },
        readingAgeYears: {
            anyOf: [
                {
                    $ref: '#/components/schemas/FirestoreProductAgeRange'
                },
                {
                    type: 'null'
                }
            ]
        }
    },
    type: 'object',
    title: 'FirestoreProductAgeRanges',
    description: 'ONIX List 30 qualifiers 16/17/18 (see ``get_age_ranges``).'
} as const;

export const FirestoreProductBisacSubjectSchema = {
    properties: {
        id: {
            type: 'string',
            title: 'Id',
            description: 'The identifier of the product\'s BISAC subject'
        },
        subjectCode: {
            type: 'string',
            title: 'Subjectcode',
            description: 'The BISAC subject code',
            default: ''
        },
        subjectHeadingText: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Subjectheadingtext'
        },
        source: {
            $ref: '#/components/schemas/SubjectSource',
            description: 'Who created the entry; never rewritten once set',
            default: 'DATABASE'
        },
        inSource: {
            type: 'boolean',
            title: 'Insource',
            description: 'Whether the latest imported ONIX file still carries the code',
            default: false
        },
        final: {
            type: 'boolean',
            title: 'Final',
            description: 'Whether the user selected the code',
            default: false
        },
        orderIndex: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Orderindex',
            description: 'Position among the codes the user selected'
        },
        seq: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Seq',
            description: 'Position of the code in the BISAC catalogue; set only when subjectHeadingText is the catalogue heading'
        }
    },
    type: 'object',
    required: [
        'id'
    ],
    title: 'FirestoreProductBisacSubject',
    description: 'A BISAC code on a product, ordered by list position until the user selects it.\n\nA ``MANUAL`` entry is always ``final``: it exists only because the user selected\nit, and an entry that is neither ``inSource`` nor ``final`` is deleted on the next\nimport.'
} as const;

export const FirestoreProductCategorizationSchema = {
    properties: {
        fiction: {
            type: 'boolean',
            title: 'Fiction',
            default: true
        },
        nonFiction: {
            type: 'boolean',
            title: 'Nonfiction',
            default: true
        },
        children: {
            type: 'boolean',
            title: 'Children',
            default: true
        },
        updatedAt: {
            anyOf: [
                {
                    type: 'string',
                    format: 'date-time'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Updatedat'
        },
        inferredFrom: {
            anyOf: [
                {
                    type: 'string',
                    enum: [
                        'THEMA',
                        'LLM'
                    ]
                },
                {
                    type: 'null'
                }
            ],
            title: 'Inferredfrom'
        }
    },
    type: 'object',
    title: 'FirestoreProductCategorization'
} as const;

export const FirestoreProductDescriptionSchema = {
    properties: {
        hash: {
            type: 'string',
            title: 'Hash',
            default: ''
        },
        default: {
            type: 'boolean',
            title: 'Default',
            default: false
        },
        textGenerated: {
            type: 'string',
            title: 'Textgenerated',
            default: ''
        },
        text: {
            type: 'string',
            title: 'Text',
            default: ''
        },
        textFormat: {
            type: 'string',
            title: 'Textformat',
            default: ''
        },
        textType: {
            type: 'string',
            title: 'Texttype',
            default: ''
        },
        audiences: {
            items: {
                type: 'string'
            },
            type: 'array',
            title: 'Audiences',
            default: []
        }
    },
    type: 'object',
    title: 'FirestoreProductDescription'
} as const;

export const FirestoreProductDimensionsSchema = {
    properties: {
        width: {
            anyOf: [
                {
                    type: 'number'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Width'
        },
        height: {
            anyOf: [
                {
                    type: 'number'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Height'
        },
        thickness: {
            anyOf: [
                {
                    type: 'number'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Thickness'
        },
        weight: {
            anyOf: [
                {
                    type: 'number'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Weight'
        },
        pages: {
            anyOf: [
                {
                    type: 'number'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Pages'
        },
        flaps: {
            anyOf: [
                {
                    type: 'number'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Flaps'
        }
    },
    type: 'object',
    title: 'FirestoreProductDimensions',
    description: 'Lengths in mm, weight in grams; keys match ``normalize_dimensions`` output.'
} as const;

export const FirestoreProductIdentifierSchema = {
    properties: {
        type: {
            type: 'string',
            title: 'Type'
        },
        value: {
            type: 'string',
            title: 'Value'
        }
    },
    type: 'object',
    required: [
        'type',
        'value'
    ],
    title: 'FirestoreProductIdentifier'
} as const;

export const FirestoreProductImagesSchema = {
    properties: {
        frontCoverUrl: {
            type: 'string',
            title: 'Frontcoverurl',
            default: ''
        },
        backCoverUrl: {
            type: 'string',
            title: 'Backcoverurl',
            default: ''
        },
        supportingResources: {
            items: {
                additionalProperties: true,
                type: 'object'
            },
            type: 'array',
            title: 'Supportingresources'
        }
    },
    type: 'object',
    title: 'FirestoreProductImages'
} as const;

export const FirestoreProductImportSchema = {
    properties: {
        id: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Id'
        },
        baseProduct: {
            $ref: '#/components/schemas/FirestoreProductImportBaseProductData'
        },
        product: {
            $ref: '#/components/schemas/FirestoreProductImportProductOnixV3Data'
        },
        importData: {
            $ref: '#/components/schemas/FirestoreProductImportImportData'
        },
        header: {
            $ref: '#/components/schemas/FirestoreProductImportHeaderData'
        }
    },
    type: 'object',
    required: [
        'id',
        'baseProduct',
        'product',
        'importData',
        'header'
    ],
    title: 'FirestoreProductImport'
} as const;

export const FirestoreProductImportBaseProductDataSchema = {
    properties: {
        titles: {
            items: {
                $ref: '#/components/schemas/FirestoreProductImportBaseProductDataTitleItem'
            },
            type: 'array',
            minItems: 1,
            title: 'Titles'
        },
        texts: {
            items: {
                $ref: '#/components/schemas/FirestoreProductImportBaseProductDataText'
            },
            type: 'array',
            title: 'Texts'
        },
        contributors: {
            items: {
                $ref: '#/components/schemas/FirestoreProductImportBaseProductDataContributorItem'
            },
            type: 'array',
            title: 'Contributors'
        },
        subjects: {
            $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjects'
        },
        publishers: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataPublisherItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Publishers',
            default: []
        },
        salesRightss: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSalesRights'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Salesrightss'
        },
        imprints: {
            items: {
                $ref: '#/components/schemas/FirestoreProductImportBaseProductDataImprints'
            },
            type: 'array',
            title: 'Imprints'
        },
        collections: {
            items: {
                $ref: '#/components/schemas/FirestoreProductImportBaseProductDataCollections'
            },
            type: 'array',
            title: 'Collections'
        },
        description: {
            $ref: '#/components/schemas/FirestoreProductImportBaseProductDataDescription'
        },
        supplyDetails: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSupplyDetailsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Supplydetails',
            default: []
        },
        info: {
            $ref: '#/components/schemas/FirestoreProductImportBaseProductDataInfo'
        },
        publishingDetails: {
            $ref: '#/components/schemas/FirestoreProductImportBaseProductDataPublishingDetails'
        }
    },
    type: 'object',
    required: [
        'titles',
        'texts',
        'contributors',
        'subjects',
        'salesRightss',
        'imprints',
        'collections',
        'description',
        'info',
        'publishingDetails'
    ],
    title: 'FirestoreProductImportBaseProductData'
} as const;

export const FirestoreProductImportBaseProductDataCollectionSeriesIdentifierSchema = {
    properties: {
        collectionIDType: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Collectionidtype'
        },
        idTypeName: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Idtypename'
        },
        idValue: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Idvalue'
        }
    },
    type: 'object',
    title: 'FirestoreProductImportBaseProductDataCollectionSeriesIdentifier'
} as const;

export const FirestoreProductImportBaseProductDataCollectionTitleSchema = {
    properties: {
        titleType: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Titletype'
        },
        titleText: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Titletext'
        }
    },
    type: 'object',
    title: 'FirestoreProductImportBaseProductDataCollectionTitle'
} as const;

export const FirestoreProductImportBaseProductDataCollectionsSchema = {
    properties: {
        mainTitle: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Maintitle'
        },
        numberWithinSeries: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Numberwithinseries'
        },
        seriesIdentifiers: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataCollectionSeriesIdentifier'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Seriesidentifiers'
        },
        titles: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataCollectionTitle'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Titles'
        },
        contributors: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataContributorItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Contributors'
        }
    },
    type: 'object',
    title: 'FirestoreProductImportBaseProductDataCollections'
} as const;

export const FirestoreProductImportBaseProductDataContributorItemSchema = {
    properties: {
        contributorRoles: {
            anyOf: [
                {
                    items: {
                        type: 'string'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Contributorroles',
            default: []
        },
        sequenceNumber: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Sequencenumber'
        },
        personName: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Personname'
        },
        personNameInverted: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Personnameinverted'
        },
        biographicalNote: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Biographicalnote'
        },
        personNameKey: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Personnamekey'
        },
        personNameBeforeKey: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Personnamebeforekey'
        },
        corporateName: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Corporatename'
        }
    },
    type: 'object',
    title: 'FirestoreProductImportBaseProductDataContributorItem'
} as const;

export const FirestoreProductImportBaseProductDataDescriptionSchema = {
    properties: {
        productForm: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Productform'
        },
        productFormDetail: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Productformdetail'
        },
        numberOfPages: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Numberofpages'
        },
        editionType: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Editiontype'
        },
        editionNumber: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Editionnumber'
        },
        audienceDescription: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Audiencedescription'
        },
        languages: {
            items: {
                $ref: '#/components/schemas/FirestoreProductImportBaseProductDataDescriptionLanguage'
            },
            type: 'array',
            title: 'Languages'
        },
        audiences: {
            items: {
                $ref: '#/components/schemas/FirestoreProductImportBaseProductDataDescriptionAudiencesItem'
            },
            type: 'array',
            title: 'Audiences'
        },
        audienceRange: {
            anyOf: [
                {
                    $ref: '#/components/schemas/FirestoreProductImportBaseProductDataDescriptionAudienceRange'
                },
                {
                    type: 'null'
                }
            ]
        }
    },
    type: 'object',
    required: [
        'languages',
        'audiences'
    ],
    title: 'FirestoreProductImportBaseProductDataDescription'
} as const;

export const FirestoreProductImportBaseProductDataDescriptionAudienceRangeSchema = {
    properties: {
        audienceRangeQualifier: {
            type: 'string',
            title: 'Audiencerangequalifier'
        },
        audienceRangeValues: {
            items: {
                type: 'string'
            },
            type: 'array',
            title: 'Audiencerangevalues'
        },
        audienceRangePrecisions: {
            items: {
                type: 'string'
            },
            type: 'array',
            title: 'Audiencerangeprecisions'
        }
    },
    type: 'object',
    required: [
        'audienceRangeQualifier',
        'audienceRangeValues',
        'audienceRangePrecisions'
    ],
    title: 'FirestoreProductImportBaseProductDataDescriptionAudienceRange'
} as const;

export const FirestoreProductImportBaseProductDataDescriptionAudiencesItemSchema = {
    properties: {
        audienceCodeType: {
            type: 'string',
            title: 'Audiencecodetype'
        },
        audienceCodeValue: {
            type: 'string',
            title: 'Audiencecodevalue'
        },
        audienceCodeTypeName: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Audiencecodetypename'
        }
    },
    type: 'object',
    required: [
        'audienceCodeType',
        'audienceCodeValue'
    ],
    title: 'FirestoreProductImportBaseProductDataDescriptionAudiencesItem'
} as const;

export const FirestoreProductImportBaseProductDataDescriptionLanguageSchema = {
    properties: {
        languageRole: {
            type: 'string',
            title: 'Languagerole'
        },
        languageCode: {
            type: 'string',
            title: 'Languagecode'
        }
    },
    type: 'object',
    required: [
        'languageRole',
        'languageCode'
    ],
    title: 'FirestoreProductImportBaseProductDataDescriptionLanguage'
} as const;

export const FirestoreProductImportBaseProductDataImprintsSchema = {
    properties: {
        imprintName: {
            type: 'string',
            title: 'Imprintname'
        }
    },
    type: 'object',
    required: [
        'imprintName'
    ],
    title: 'FirestoreProductImportBaseProductDataImprints'
} as const;

export const FirestoreProductImportBaseProductDataInfoSchema = {
    properties: {
        productIds: {
            items: {
                $ref: '#/components/schemas/FirestoreProductImportBaseProductDataInfoProductIdItem'
            },
            type: 'array',
            title: 'Productids'
        },
        recordReference: {
            type: 'string',
            title: 'Recordreference'
        },
        notificationType: {
            type: 'string',
            title: 'Notificationtype'
        }
    },
    type: 'object',
    required: [
        'productIds',
        'recordReference',
        'notificationType'
    ],
    title: 'FirestoreProductImportBaseProductDataInfo'
} as const;

export const FirestoreProductImportBaseProductDataInfoProductIdItemSchema = {
    properties: {
        productIDType: {
            type: 'string',
            title: 'Productidtype'
        },
        idValue: {
            type: 'string',
            title: 'Idvalue'
        },
        idTypeName: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Idtypename'
        }
    },
    type: 'object',
    required: [
        'productIDType',
        'idValue'
    ],
    title: 'FirestoreProductImportBaseProductDataInfoProductIdItem'
} as const;

export const FirestoreProductImportBaseProductDataPublisherItemSchema = {
    properties: {
        publisherName: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Publishername'
        },
        publishingRole: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Publishingrole'
        }
    },
    type: 'object',
    title: 'FirestoreProductImportBaseProductDataPublisherItem'
} as const;

export const FirestoreProductImportBaseProductDataPublishingDetailsSchema = {
    properties: {
        publicationDate: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Publicationdate'
        },
        outOfPrintDate: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Outofprintdate'
        },
        countryOfPublication: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Countryofpublication'
        },
        cityOfPublication: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Cityofpublication'
        }
    },
    type: 'object',
    title: 'FirestoreProductImportBaseProductDataPublishingDetails'
} as const;

export const FirestoreProductImportBaseProductDataSalesRightsSchema = {
    properties: {
        salesRightsType: {
            type: 'string',
            title: 'Salesrightstype'
        },
        countries: {
            anyOf: [
                {
                    items: {
                        type: 'string'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Countries',
            default: []
        },
        regions: {
            anyOf: [
                {
                    items: {
                        type: 'string'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Regions',
            default: []
        },
        rightRegions: {
            anyOf: [
                {
                    items: {
                        type: 'string'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Rightregions'
        },
        countriesExcluded: {
            anyOf: [
                {
                    items: {
                        type: 'string'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Countriesexcluded'
        },
        regionsExcluded: {
            anyOf: [
                {
                    items: {
                        type: 'string'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Regionsexcluded'
        }
    },
    type: 'object',
    required: [
        'salesRightsType'
    ],
    title: 'FirestoreProductImportBaseProductDataSalesRights'
} as const;

export const FirestoreProductImportBaseProductDataSubjectsSchema = {
    properties: {
        Thema_subject_category: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Thema Subject Category'
        },
        Keywords: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Keywords'
        },
        BISAC_Subject_Heading: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Bisac Subject Heading'
        },
        BIC_subject_category: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Bic Subject Category'
        },
        BIC_time_period_qualifier: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Bic Time Period Qualifier'
        },
        Thema_time_period_qualifier: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Thema Time Period Qualifier'
        },
        Thema_place_qualifier: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Thema Place Qualifier'
        },
        Dewey: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Dewey'
        },
        Abridged_Dewey: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Abridged Dewey'
        },
        LC_classification: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Lc Classification'
        },
        LC_subject_heading: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Lc Subject Heading'
        },
        NLM_classification: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Nlm Classification'
        },
        MeSH_heading: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Mesh Heading'
        },
        NAL_subject_heading: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Nal Subject Heading'
        },
        AAT: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Aat'
        },
        UDC: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Udc'
        },
        BISAC_Regional_theme: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Bisac Regional Theme'
        },
        BIC_geographical_qualifier: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Bic Geographical Qualifier'
        },
        BIC_language_qualifier_language_as_subject: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Bic Language Qualifier Language As Subject'
        },
        BIC_educational_purpose_qualifier: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Bic Educational Purpose Qualifier'
        },
        BIC_reading_level_and_special_interest_qualifier: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Bic Reading Level And Special Interest Qualifier'
        },
        DDC_Sachgruppen_der_Deutschen_Nationalbibliografie: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ddc Sachgruppen Der Deutschen Nationalbibliografie'
        },
        LC_fiction_genre_heading: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Lc Fiction Genre Heading'
        },
        BIC_childrens_book_marketing_category: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Bic Childrens Book Marketing Category'
        },
        BISAC_Merchandising_Theme: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Bisac Merchandising Theme'
        },
        Publishers_own_category_code: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Publishers Own Category Code'
        },
        Proprietary_subject_scheme: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Proprietary Subject Scheme'
        },
        Tabla_de_materias_ISBN: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Tabla De Materias Isbn'
        },
        Warengruppen_Systematik_des_deutschen_Buchhandels: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Warengruppen Systematik Des Deutschen Buchhandels'
        },
        SWD: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Swd'
        },
        Themes_Electre: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Themes Electre'
        },
        CLIL_Classification_thematique: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Clil Classification Thematique'
        },
        DNB_Sachgruppen: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Dnb Sachgruppen'
        },
        NUGI: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Nugi'
        },
        NUR: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Nur'
        },
        ECPA_Christian_Book_Category: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ecpa Christian Book Category'
        },
        SISO: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Siso'
        },
        Korean_Decimal_Classification_KDC: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Korean Decimal Classification Kdc'
        },
        DDC_Deutsch_22: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ddc Deutsch 22'
        },
        Bokgrupper: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Bokgrupper'
        },
        Varegrupper: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Varegrupper'
        },
        Lreplaner_KL06: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Lreplaner Kl06'
        },
        Nippon_Decimal_Classification: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Nippon Decimal Classification'
        },
        BSQ: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Bsq'
        },
        ANELE_Materias: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Anele Materias'
        },
        Utdanningsprogram: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Utdanningsprogram'
        },
        Programomrade: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Programomrade'
        },
        Undervisningsmateriell: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Undervisningsmateriell'
        },
        Norsk_DDK: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Norsk Ddk'
        },
        Varugrupper: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Varugrupper'
        },
        SAB: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Sab'
        },
        Laromedelstyp: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Laromedelstyp'
        },
        Forhandsbeskrivning: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Forhandsbeskrivning'
        },
        Spanish_ISBN_UDC_subset: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Spanish Isbn Udc Subset'
        },
        ECI_subject_categories: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Eci Subject Categories'
        },
        Soggetto_CCE: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Soggetto Cce'
        },
        Qualificatore_geografico_CCE: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Qualificatore Geografico Cce'
        },
        Qualificatore_di_lingua_CCE: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Qualificatore Di Lingua Cce'
        },
        Qualificatore_di_periodo_storico_CCE: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Qualificatore Di Periodo Storico Cce'
        },
        Qualificatore_di_livello_scolastico_CCE: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Qualificatore Di Livello Scolastico Cce'
        },
        Qualificatore_di_eta_di_lettura_CCE: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Qualificatore Di Eta Di Lettura Cce'
        },
        VdS_Bildungsmedien_Facher: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Vds Bildungsmedien Facher'
        },
        Fagkoder: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Fagkoder'
        },
        JEL_classification: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Jel Classification'
        },
        CSH: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Csh'
        },
        RVM: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Rvm'
        },
        YSA: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ysa'
        },
        Allars: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Allars'
        },
        YKL: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ykl'
        },
        MUSA: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Musa'
        },
        CILLA: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Cilla'
        },
        Kaunokki: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Kaunokki'
        },
        Bella: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Bella'
        },
        YSO: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Yso'
        },
        PTO: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Pto'
        },
        Suomalainen_kirja_alan_luokitus: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Suomalainen Kirja Alan Luokitus'
        },
        Sears: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Sears'
        },
        BIC_E4L: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Bic E4L'
        },
        CSR: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Csr'
        },
        Suomalainen_oppiaineluokitus: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Suomalainen Oppiaineluokitus'
        },
        Japanese_book_trade_C_Code: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Japanese Book Trade C Code'
        },
        Japanese_book_trade_Genre_Code: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Japanese Book Trade Genre Code'
        },
        Fiktiivisen_aineiston_lisaluokitus: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Fiktiivisen Aineiston Lisaluokitus'
        },
        Arabic_Subject_heading_scheme: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Arabic Subject Heading Scheme'
        },
        Arabized_BIC_subject_category: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Arabized Bic Subject Category'
        },
        Arabized_LC_subject_headings: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Arabized Lc Subject Headings'
        },
        Bibliotheca_Alexandrina_Subject_Headings: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Bibliotheca Alexandrina Subject Headings'
        },
        Postal_code: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Postal Code'
        },
        GeoNames_ID: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Geonames Id'
        },
        NewBooks_Subject_Classification: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Newbooks Subject Classification'
        },
        Chinese_Library_Classification: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Chinese Library Classification'
        },
        NTCPDSAC_Classification: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ntcpdsac Classification'
        },
        Season_and_Event_Indicator: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Season And Event Indicator'
        },
        GND: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Gnd'
        },
        BIC_UKSLC: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Bic Ukslc'
        },
        Thema_educational_purpose_qualifier: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Thema Educational Purpose Qualifier'
        },
        Thema_interest_age_special_interest_qualifier: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Thema Interest Age Special Interest Qualifier'
        },
        Thema_style_qualifier: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Thema Style Qualifier'
        },
        Thema_language_qualifier: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Thema Language Qualifier'
        },
        Amnesord: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Amnesord'
        },
        Statystyka_Ksiazek_Papierowych_Mowionych_I_Elektronicznych: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Statystyka Ksiazek Papierowych Mowionych I Elektronicznych'
        },
        CCSS: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ccss'
        },
        Rameau: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Rameau'
        },
        Nomenclature_discipline_scolaire: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Nomenclature Discipline Scolaire'
        },
        ISIC: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Isic'
        },
        LC_Childrens_Subject_Headings: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Lc Childrens Subject Headings'
        },
        Ny_Laromedel: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ny Laromedel'
        },
        EuroVoc: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Eurovoc'
        },
        BISG_Educational_Taxonomy: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Bisg Educational Taxonomy'
        },
        Keywords_not_for_display: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Keywords Not For Display'
        },
        Nomenclature_Diplome: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Nomenclature Diplome'
        },
        Key_character_names: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Key Character Names'
        },
        Key_place_names: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Key Place Names'
        },
        FAST: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Fast'
        },
        NGSS: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ngss'
        },
        MVB_Lesemotive: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Mvb Lesemotive'
        },
        LOPS21_Subject_module: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Lops21 Subject Module'
        },
        Lreplaner_LK20: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Lreplaner Lk20'
        },
        Kompetansemal_LK20: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Kompetansemal Lk20'
        },
        Kompetansemalsett_LK20: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Kompetansemalsett Lk20'
        },
        Tverrfaglige_temaer_LK20: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Tverrfaglige Temaer Lk20'
        },
        CLIL_Type_darticle_scolaire: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Clil Type Darticle Scolaire'
        },
        GAR_Type_pedagogique: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Gar Type Pedagogique'
        },
        ISCED_F: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Isced F'
        },
        Klassifikationen_von_Spielen_Puzzles_und_Spielwaren: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Klassifikationen Von Spielen Puzzles Und Spielwaren'
        },
        NBVok_NTSF: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Nbvok Ntsf'
        },
        JPRO_Genre: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Jpro Genre'
        },
        KAUNO: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Kauno'
        },
        SLM: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Slm'
        },
        YSO_places: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSubjectsItem'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Yso Places'
        }
    },
    additionalProperties: true,
    type: 'object',
    title: 'FirestoreProductImportBaseProductDataSubjects'
} as const;

export const FirestoreProductImportBaseProductDataSubjectsItemSchema = {
    properties: {
        subjectSchemeIdentifier: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Subjectschemeidentifier'
        },
        subjectHeadingText: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Subjectheadingtext'
        },
        subjectCode: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Subjectcode'
        }
    },
    type: 'object',
    title: 'FirestoreProductImportBaseProductDataSubjectsItem'
} as const;

export const FirestoreProductImportBaseProductDataSupplyDetailsItemSchema = {
    properties: {
        supplierName: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Suppliername'
        },
        supplierRole: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Supplierrole'
        },
        availability: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Availability'
        },
        prices: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportBaseProductDataSupplyDetailsItemPrice'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Prices'
        }
    },
    type: 'object',
    title: 'FirestoreProductImportBaseProductDataSupplyDetailsItem'
} as const;

export const FirestoreProductImportBaseProductDataSupplyDetailsItemPriceSchema = {
    properties: {
        priceType: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Pricetype'
        },
        priceAmountAsStr: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Priceamountasstr'
        },
        priceAmount: {
            anyOf: [
                {
                    type: 'number'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Priceamount'
        },
        currencyCode: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Currencycode'
        }
    },
    type: 'object',
    required: [
        'priceAmount'
    ],
    title: 'FirestoreProductImportBaseProductDataSupplyDetailsItemPrice'
} as const;

export const FirestoreProductImportBaseProductDataTextSchema = {
    properties: {
        default: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Default',
            default: false
        },
        hash: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Hash'
        },
        textType: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Texttype'
        },
        text: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Text'
        },
        textFormat: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Textformat'
        },
        audiences: {
            anyOf: [
                {
                    items: {
                        type: 'string'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Audiences',
            default: []
        }
    },
    type: 'object',
    title: 'FirestoreProductImportBaseProductDataText'
} as const;

export const FirestoreProductImportBaseProductDataTitleItemSchema = {
    properties: {
        titleType: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Titletype'
        },
        subtitle: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Subtitle'
        },
        titleText: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Titletext'
        },
        prefix: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Prefix',
            default: ''
        },
        titleWithoutPrefix: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Titlewithoutprefix',
            default: ''
        }
    },
    type: 'object',
    title: 'FirestoreProductImportBaseProductDataTitleItem'
} as const;

export const FirestoreProductImportDataSchema = {
    properties: {
        importId: {
            type: 'string',
            title: 'Importid'
        },
        productsImportId: {
            type: 'string',
            title: 'Productsimportid'
        },
        objectName: {
            type: 'string',
            title: 'Objectname'
        },
        folderName: {
            type: 'string',
            title: 'Foldername'
        },
        fileName: {
            type: 'string',
            title: 'Filename'
        },
        chunkId: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Chunkid'
        }
    },
    type: 'object',
    required: [
        'importId',
        'productsImportId',
        'objectName',
        'folderName',
        'fileName'
    ],
    title: 'FirestoreProductImportData'
} as const;

export const FirestoreProductImportHeaderDataSchema = {
    properties: {
        senderName: {
            type: 'string',
            title: 'Sendername'
        },
        sentDateTime: {
            type: 'string',
            title: 'Sentdatetime'
        },
        senderEmail: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Senderemail'
        },
        senderContactName: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Sendercontactname'
        },
        addressees: {
            anyOf: [
                {
                    items: {
                        type: 'string'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Addressees'
        }
    },
    type: 'object',
    required: [
        'senderName',
        'sentDateTime'
    ],
    title: 'FirestoreProductImportHeaderData'
} as const;

export const FirestoreProductImportImportDataSchema = {
    properties: {
        bucketName: {
            type: 'string',
            title: 'Bucketname'
        },
        importId: {
            type: 'string',
            title: 'Importid'
        },
        chunkId: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Chunkid'
        },
        objectName: {
            type: 'string',
            title: 'Objectname'
        },
        folderName: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Foldername'
        },
        fileName: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Filename'
        },
        projectId: {
            type: 'string',
            title: 'Projectid'
        },
        onixRelease: {
            type: 'string',
            title: 'Onixrelease'
        },
        onixVersion: {
            type: 'string',
            title: 'Onixversion'
        },
        productCount: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Productcount'
        },
        productGlobalCount: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Productglobalcount'
        },
        sourceName: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Sourcename'
        },
        reportingTopicName: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Reportingtopicname'
        },
        topicName: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Topicname'
        }
    },
    type: 'object',
    required: [
        'bucketName',
        'importId',
        'objectName',
        'projectId',
        'onixRelease',
        'onixVersion'
    ],
    title: 'FirestoreProductImportImportData'
} as const;

export const FirestoreProductImportProductOnixV3DataSchema = {
    properties: {
        descriptiveDetail: {
            $ref: '#/components/schemas/FirestoreProductImportProductOnixV3DataDescriptiveDetail'
        },
        relatedMaterial: {
            anyOf: [
                {
                    $ref: '#/components/schemas/FirestoreProductImportProductOnixV3DataRelatedMaterial'
                },
                {
                    type: 'null'
                }
            ]
        },
        collateralDetail: {
            anyOf: [
                {
                    $ref: '#/components/schemas/FirestoreProductImportProductOnixV3DataCollateralDetail'
                },
                {
                    type: 'null'
                }
            ]
        },
        publishingDetail: {
            anyOf: [
                {
                    $ref: '#/components/schemas/FirestoreProductImportProductOnixV3DataPublishingDetail'
                },
                {
                    type: 'null'
                }
            ]
        }
    },
    additionalProperties: true,
    type: 'object',
    required: [
        'descriptiveDetail'
    ],
    title: 'FirestoreProductImportProductOnixV3Data'
} as const;

export const FirestoreProductImportProductOnixV3DataCollateralDetailSchema = {
    properties: {
        textContents: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportProductOnixV3DataCollateralDetailTextContent'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Textcontents'
        },
        supportingResources: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportProductOnixV3DataCollateralDetailSupportingResource'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Supportingresources'
        }
    },
    type: 'object',
    title: 'FirestoreProductImportProductOnixV3DataCollateralDetail'
} as const;

export const FirestoreProductImportProductOnixV3DataCollateralDetailResourceLinkSchema = {
    properties: {
        value: {
            type: 'string',
            title: 'Value'
        }
    },
    type: 'object',
    required: [
        'value'
    ],
    title: 'FirestoreProductImportProductOnixV3DataCollateralDetailResourceLink'
} as const;

export const FirestoreProductImportProductOnixV3DataCollateralDetailResourceVersionSchema = {
    properties: {
        resourceLinks: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportProductOnixV3DataCollateralDetailResourceLink'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Resourcelinks'
        }
    },
    additionalProperties: true,
    type: 'object',
    title: 'FirestoreProductImportProductOnixV3DataCollateralDetailResourceVersion'
} as const;

export const FirestoreProductImportProductOnixV3DataCollateralDetailSupportingResourceSchema = {
    properties: {
        resourceContentType: {
            anyOf: [
                {
                    $ref: '#/components/schemas/FirestoreProductImportProductOnixV3DataValueContainer'
                },
                {
                    type: 'null'
                }
            ]
        },
        resourceMode: {
            anyOf: [
                {
                    $ref: '#/components/schemas/FirestoreProductImportProductOnixV3DataValueContainer'
                },
                {
                    type: 'null'
                }
            ]
        },
        resourceVersions: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportProductOnixV3DataCollateralDetailResourceVersion'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Resourceversions'
        }
    },
    additionalProperties: true,
    type: 'object',
    title: 'FirestoreProductImportProductOnixV3DataCollateralDetailSupportingResource'
} as const;

export const FirestoreProductImportProductOnixV3DataCollateralDetailTextContentSchema = {
    properties: {
        contentAudiences: {
            items: {
                $ref: '#/components/schemas/FirestoreProductImportProductOnixV3DataValueContainer'
            },
            type: 'array',
            title: 'Contentaudiences'
        },
        textType: {
            $ref: '#/components/schemas/FirestoreProductImportProductOnixV3DataValueContainer'
        },
        texts: {
            items: {
                $ref: '#/components/schemas/FirestoreProductImportProductOnixV3DataCollateralDetailTextContentText'
            },
            type: 'array',
            title: 'Texts'
        }
    },
    type: 'object',
    required: [
        'contentAudiences',
        'textType',
        'texts'
    ],
    title: 'FirestoreProductImportProductOnixV3DataCollateralDetailTextContent'
} as const;

export const FirestoreProductImportProductOnixV3DataCollateralDetailTextContentTextSchema = {
    properties: {
        textformat: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    $ref: '#/components/schemas/FirestoreProductImportProductOnixV3DataCollateralDetailTextContentTextTextFormatValue'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Textformat'
        },
        value: {
            type: 'string',
            title: 'Value'
        }
    },
    type: 'object',
    required: [
        'value'
    ],
    title: 'FirestoreProductImportProductOnixV3DataCollateralDetailTextContentText'
} as const;

export const FirestoreProductImportProductOnixV3DataCollateralDetailTextContentTextTextFormatValueSchema = {
    properties: {
        value: {
            type: 'string',
            title: 'Value'
        }
    },
    type: 'object',
    required: [
        'value'
    ],
    title: 'FirestoreProductImportProductOnixV3DataCollateralDetailTextContentTextTextFormatValue'
} as const;

export const FirestoreProductImportProductOnixV3DataDescriptiveDetailSchema = {
    properties: {
        productFormDetails: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportProductOnixV3DataValueContainer'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Productformdetails',
            default: []
        },
        productForm: {
            anyOf: [
                {
                    $ref: '#/components/schemas/FirestoreProductImportProductOnixV3DataValueContainer'
                },
                {
                    type: 'null'
                }
            ]
        }
    },
    additionalProperties: true,
    type: 'object',
    required: [
        'productForm'
    ],
    title: 'FirestoreProductImportProductOnixV3DataDescriptiveDetail'
} as const;

export const FirestoreProductImportProductOnixV3DataPublishingDetailSchema = {
    properties: {
        publishers: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportProductOnixV3DataPublishingDetailPublisher'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Publishers'
        }
    },
    additionalProperties: true,
    type: 'object',
    title: 'FirestoreProductImportProductOnixV3DataPublishingDetail'
} as const;

export const FirestoreProductImportProductOnixV3DataPublishingDetailPublisherSchema = {
    properties: {
        publisherNames: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportProductOnixV3DataValueContainer'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Publishernames'
        },
        publishingRole: {
            anyOf: [
                {
                    $ref: '#/components/schemas/FirestoreProductImportProductOnixV3DataValueContainer'
                },
                {
                    type: 'null'
                }
            ]
        },
        websites: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportProductOnixV3DataPublishingDetailPublisherWebsite'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Websites'
        }
    },
    additionalProperties: true,
    type: 'object',
    title: 'FirestoreProductImportProductOnixV3DataPublishingDetailPublisher'
} as const;

export const FirestoreProductImportProductOnixV3DataPublishingDetailPublisherWebsiteSchema = {
    properties: {
        websiteRole: {
            anyOf: [
                {
                    $ref: '#/components/schemas/FirestoreProductImportProductOnixV3DataValueContainer'
                },
                {
                    type: 'null'
                }
            ]
        },
        websiteLinks: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportProductOnixV3DataPublishingDetailPublisherWebsiteLink'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Websitelinks'
        }
    },
    additionalProperties: true,
    type: 'object',
    title: 'FirestoreProductImportProductOnixV3DataPublishingDetailPublisherWebsite'
} as const;

export const FirestoreProductImportProductOnixV3DataPublishingDetailPublisherWebsiteLinkSchema = {
    properties: {
        value: {
            type: 'string',
            title: 'Value'
        }
    },
    type: 'object',
    required: [
        'value'
    ],
    title: 'FirestoreProductImportProductOnixV3DataPublishingDetailPublisherWebsiteLink'
} as const;

export const FirestoreProductImportProductOnixV3DataRelatedMaterialSchema = {
    properties: {
        relatedProducts: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportProductOnixV3DataRelatedMaterialRelatedProduct'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Relatedproducts',
            default: []
        },
        relatedWorks: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportProductOnixV3DataRelatedMaterialWorks'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Relatedworks',
            default: []
        }
    },
    type: 'object',
    title: 'FirestoreProductImportProductOnixV3DataRelatedMaterial'
} as const;

export const FirestoreProductImportProductOnixV3DataRelatedMaterialRelatedProductSchema = {
    properties: {
        productIdentifiers: {
            items: {
                $ref: '#/components/schemas/FirestoreProductImportProductOnixV3DataRelatedMaterialRelatedProductIdentifiers'
            },
            type: 'array',
            title: 'Productidentifiers'
        },
        productForm: {
            anyOf: [
                {
                    $ref: '#/components/schemas/FirestoreProductImportProductOnixV3DataValueContainer'
                },
                {
                    type: 'null'
                }
            ]
        },
        productRelationCodes: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportProductOnixV3DataValueContainer'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Productrelationcodes',
            default: []
        },
        productFormDetails: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductImportProductOnixV3DataValueContainer'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Productformdetails',
            default: []
        }
    },
    type: 'object',
    required: [
        'productIdentifiers'
    ],
    title: 'FirestoreProductImportProductOnixV3DataRelatedMaterialRelatedProduct'
} as const;

export const FirestoreProductImportProductOnixV3DataRelatedMaterialRelatedProductIdentifiersSchema = {
    properties: {
        productIDType: {
            $ref: '#/components/schemas/FirestoreProductImportProductOnixV3DataValueContainer'
        },
        idValue: {
            anyOf: [
                {
                    $ref: '#/components/schemas/FirestoreProductImportProductOnixV3DataValueContainer'
                },
                {
                    type: 'null'
                }
            ]
        },
        idTypeName: {
            anyOf: [
                {
                    $ref: '#/components/schemas/FirestoreProductImportProductOnixV3DataValueContainer'
                },
                {
                    type: 'null'
                }
            ]
        }
    },
    type: 'object',
    required: [
        'productIDType'
    ],
    title: 'FirestoreProductImportProductOnixV3DataRelatedMaterialRelatedProductIdentifiers'
} as const;

export const FirestoreProductImportProductOnixV3DataRelatedMaterialWorksSchema = {
    properties: {
        workRelationCode: {
            $ref: '#/components/schemas/FirestoreProductImportProductOnixV3DataValueContainer'
        },
        workIdentifiers: {
            items: {
                $ref: '#/components/schemas/FirestoreProductImportProductOnixV3DataRelatedMaterialWorksIdentifier'
            },
            type: 'array',
            title: 'Workidentifiers'
        }
    },
    type: 'object',
    required: [
        'workRelationCode',
        'workIdentifiers'
    ],
    title: 'FirestoreProductImportProductOnixV3DataRelatedMaterialWorks'
} as const;

export const FirestoreProductImportProductOnixV3DataRelatedMaterialWorksIdentifierSchema = {
    properties: {
        idValue: {
            $ref: '#/components/schemas/FirestoreProductImportProductOnixV3DataValueContainer'
        },
        workIDType: {
            anyOf: [
                {
                    $ref: '#/components/schemas/FirestoreProductImportProductOnixV3DataValueContainer'
                },
                {
                    type: 'null'
                }
            ]
        },
        idTypeName: {
            anyOf: [
                {
                    $ref: '#/components/schemas/FirestoreProductImportProductOnixV3DataValueContainer'
                },
                {
                    type: 'null'
                }
            ]
        }
    },
    type: 'object',
    required: [
        'idValue'
    ],
    title: 'FirestoreProductImportProductOnixV3DataRelatedMaterialWorksIdentifier'
} as const;

export const FirestoreProductImportProductOnixV3DataValueContainerSchema = {
    properties: {
        value: {
            type: 'string',
            title: 'Value'
        }
    },
    type: 'object',
    required: [
        'value'
    ],
    title: 'FirestoreProductImportProductOnixV3DataValueContainer'
} as const;

export const FirestoreProductManuscriptSchema = {
    properties: {
        filename: {
            type: 'string',
            title: 'Filename'
        },
        uploadedAt: {
            type: 'string',
            format: 'date-time',
            title: 'Uploadedat'
        },
        analysis: {
            anyOf: [
                {
                    $ref: '#/components/schemas/FirestoreProductManuscriptAnalysis'
                },
                {
                    type: 'null'
                }
            ]
        }
    },
    type: 'object',
    required: [
        'filename',
        'uploadedAt'
    ],
    title: 'FirestoreProductManuscript'
} as const;

export const FirestoreProductManuscriptAnalysisSchema = {
    properties: {
        result: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Result'
        },
        generatedContentId: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Generatedcontentid'
        },
        generatedAt: {
            anyOf: [
                {
                    type: 'string',
                    format: 'date-time'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Generatedat'
        },
        generationRequestId: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Generationrequestid'
        }
    },
    type: 'object',
    title: 'FirestoreProductManuscriptAnalysis'
} as const;

export const FirestoreProductPublisherSchema = {
    properties: {
        name: {
            type: 'string',
            title: 'Name'
        },
        role: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Role'
        }
    },
    type: 'object',
    required: [
        'name',
        'role'
    ],
    title: 'FirestoreProductPublisher'
} as const;

export const FirestoreProductQuoteSchema = {
    properties: {
        text: {
            type: 'string',
            title: 'Text',
            default: ''
        },
        source: {
            type: 'string',
            title: 'Source',
            default: ''
        }
    },
    type: 'object',
    title: 'FirestoreProductQuote'
} as const;

export const FirestoreProductSeriesSchema = {
    properties: {
        status: {
            $ref: '#/components/schemas/SeriesStatus',
            description: 'What the publisher declared in ONIX, not a verified fact: in_series when it sent a <Collection>, not_in_series when it sent <NoCollection/>, unknown when it sent neither. Some feeds send <NoCollection/> on every product without a <Collection>.',
            default: 'unknown'
        },
        items: {
            items: {
                $ref: '#/components/schemas/FirestoreProductSeriesItem'
            },
            type: 'array',
            title: 'Items',
            default: []
        }
    },
    type: 'object',
    title: 'FirestoreProductSeries'
} as const;

export const FirestoreProductSeriesIdentifierSchema = {
    properties: {
        type: {
            type: 'string',
            title: 'Type'
        },
        idTypeName: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Idtypename'
        },
        value: {
            type: 'string',
            title: 'Value'
        }
    },
    type: 'object',
    required: [
        'type',
        'value'
    ],
    title: 'FirestoreProductSeriesIdentifier'
} as const;

export const FirestoreProductSeriesItemSchema = {
    properties: {
        title: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Title'
        },
        level: {
            anyOf: [
                {
                    $ref: '#/components/schemas/SeriesLevel'
                },
                {
                    type: 'null'
                }
            ],
            description: 'ONIX title element level (List 149) of the collection title.'
        },
        number: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Number',
            description: 'The product\'s position in the series, kept as sent (e.g. \'01\', \'1 und 2\', \'Prequel\').'
        },
        numberSource: {
            anyOf: [
                {
                    $ref: '#/components/schemas/SeriesNumberSource'
                },
                {
                    type: 'null'
                }
            ],
            description: 'The ONIX element the number comes from: <CollectionSequence> or <PartNumber>.'
        },
        orderType: {
            anyOf: [
                {
                    $ref: '#/components/schemas/SeriesOrderType'
                },
                {
                    type: 'null'
                }
            ],
            description: 'The <CollectionSequenceType> of the number. Null when the number comes from <PartNumber>, which declares no order, or when the type is not in ONIX List 197.'
        },
        identifiers: {
            items: {
                $ref: '#/components/schemas/FirestoreProductSeriesIdentifier'
            },
            type: 'array',
            title: 'Identifiers',
            default: []
        }
    },
    type: 'object',
    title: 'FirestoreProductSeriesItem',
    description: 'One ONIX <Collection> the product belongs to, as the publisher sent it.'
} as const;

export const FirestoreProductSubjectSchema = {
    properties: {
        id: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Id',
            description: 'The identifier of the product\'s subject'
        },
        responseId: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Responseid'
        },
        source: {
            anyOf: [
                {
                    $ref: '#/components/schemas/SubjectSource'
                },
                {
                    type: 'null'
                }
            ],
            default: 'MANUAL'
        },
        subjectCode: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Subjectcode'
        },
        subjectHeadingText: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Subjectheadingtext'
        },
        reasoning: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Reasoning'
        },
        subjectSchemeIdentifier: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Subjectschemeidentifier'
        },
        ranking: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ranking'
        },
        rankingReasoning: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Rankingreasoning'
        },
        keywordSearchQuery: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Keywordsearchquery'
        },
        databaseIndex: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Databaseindex'
        },
        hotnessScore: {
            anyOf: [
                {
                    type: 'number'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Hotnessscore'
        }
    },
    type: 'object',
    title: 'FirestoreProductSubject'
} as const;

export const FirestoreProductSubjectsSchema = {
    properties: {
        generated: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductSubject'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Generated',
            description: 'The generated subjects'
        },
        database: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductSubject'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Database',
            description: 'The database subjects'
        },
        final: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductSubject'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Final',
            description: 'The final keyword phrases'
        },
        finalWords: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreProductSubject'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Finalwords',
            description: 'The final unique single words derived from keyword phrases'
        },
        bisac: {
            items: {
                $ref: '#/components/schemas/FirestoreProductBisacSubject'
            },
            type: 'array',
            title: 'Bisac',
            description: 'The BISAC subject headings'
        }
    },
    additionalProperties: true,
    type: 'object',
    title: 'FirestoreProductSubjects'
} as const;

export const FirestoreProductSubtitleCandidateSchema = {
    properties: {
        subtitle: {
            type: 'string',
            title: 'Subtitle'
        },
        reasoning: {
            type: 'string',
            title: 'Reasoning'
        },
        isBestChoice: {
            anyOf: [
                {
                    type: 'boolean'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Isbestchoice'
        },
        bestChoiceReasoning: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Bestchoicereasoning'
        }
    },
    type: 'object',
    required: [
        'subtitle',
        'reasoning'
    ],
    title: 'FirestoreProductSubtitleCandidate'
} as const;

export const FirestoreProductSupplyDetailSchema = {
    properties: {
        supplierName: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Suppliername'
        },
        supplierRole: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Supplierrole'
        },
        availability: {
            $ref: '#/components/schemas/PRODUCT_AVAILABILITY_NAME_LITERAL',
            default: 'Contact_supplier'
        }
    },
    type: 'object',
    title: 'FirestoreProductSupplyDetail'
} as const;

export const FirestoreProductsByTrendSchema = {
    properties: {
        id: {
            type: 'string',
            title: 'Id'
        },
        organisation: {
            $ref: '#/components/schemas/FirestoreOrganisationReference'
        },
        newProducts: {
            items: {
                type: 'string'
            },
            type: 'array',
            title: 'Newproducts',
            default: []
        },
        trend: {
            $ref: '#/components/schemas/FirestoreTrend'
        }
    },
    type: 'object',
    required: [
        'id',
        'organisation',
        'trend'
    ],
    title: 'FirestoreProductsByTrend'
} as const;

export const FirestoreProjectSchema = {
    properties: {
        type: {
            $ref: '#/components/schemas/PROJECT_TYPE'
        },
        name: {
            type: 'string',
            title: 'Name'
        },
        isbns: {
            items: {
                type: 'string'
            },
            type: 'array',
            title: 'Isbns'
        },
        createdAt: {
            type: 'string',
            format: 'date-time',
            title: 'Createdat'
        },
        userId: {
            type: 'string',
            title: 'Userid'
        },
        organisation: {
            $ref: '#/components/schemas/FirestoreOrganisationReference'
        },
        searchOptions: {
            additionalProperties: {
                type: 'string'
            },
            type: 'object',
            title: 'Searchoptions',
            default: {}
        },
        amplifyProjectId: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Amplifyprojectid'
        }
    },
    type: 'object',
    required: [
        'type',
        'name',
        'isbns',
        'createdAt',
        'userId',
        'organisation'
    ],
    title: 'FirestoreProject'
} as const;

export const FirestoreSearchTermSchema = {
    properties: {
        id: {
            type: 'string',
            title: 'Id'
        },
        uuid: {
            type: 'string',
            title: 'Uuid'
        },
        term: {
            type: 'string',
            title: 'Term'
        },
        region: {
            type: 'string',
            title: 'Region'
        },
        rank: {
            type: 'integer',
            title: 'Rank'
        },
        searchFrequencyRank: {
            type: 'integer',
            title: 'Searchfrequencyrank'
        },
        startDate: {
            type: 'string',
            format: 'date-time',
            title: 'Startdate'
        },
        trendType: {
            $ref: '#/components/schemas/SEARCH_TERMS_TYPE'
        }
    },
    type: 'object',
    required: [
        'id',
        'uuid',
        'term',
        'region',
        'rank',
        'searchFrequencyRank',
        'startDate',
        'trendType'
    ],
    title: 'FirestoreSearchTerm',
    description: 'Model for search terms stored in Firestore - matches existing trend model structure'
} as const;

export const FirestoreSemanticDataSchema = {
    properties: {
        id: {
            type: 'string',
            title: 'Id'
        },
        reportId: {
            type: 'string',
            title: 'Reportid'
        },
        organisation: {
            $ref: '#/components/schemas/FirestoreOrganisationReference'
        },
        productId: {
            type: 'string',
            title: 'Productid'
        },
        workId: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Workid'
        },
        status: {
            type: 'string',
            title: 'Status',
            default: 'COMPLETED'
        },
        paragraphHistory: {
            items: {
                type: 'string'
            },
            type: 'array',
            title: 'Paragraphhistory'
        },
        metadata: {
            anyOf: [
                {
                    $ref: '#/components/schemas/SemanticDataMetadata'
                },
                {
                    type: 'null'
                }
            ]
        },
        synopsis: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Synopsis'
        },
        genres: {
            anyOf: [
                {
                    items: {
                        type: 'string'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Genres'
        },
        worldSettings: {
            anyOf: [
                {
                    $ref: '#/components/schemas/SemanticDataWorldSettings'
                },
                {
                    type: 'null'
                }
            ]
        },
        characters: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/SemanticDataCharacter'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Characters'
        },
        rawPayload: {
            additionalProperties: true,
            type: 'object',
            title: 'Rawpayload'
        },
        receivedAt: {
            type: 'string',
            format: 'date-time',
            title: 'Receivedat'
        },
        createdAt: {
            type: 'string',
            format: 'date-time',
            title: 'Createdat'
        },
        updatedAt: {
            anyOf: [
                {
                    type: 'string',
                    format: 'date-time'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Updatedat'
        }
    },
    type: 'object',
    required: [
        'id',
        'reportId',
        'organisation',
        'productId',
        'rawPayload',
        'receivedAt',
        'createdAt'
    ],
    title: 'FirestoreSemanticData'
} as const;

export const FirestoreTrendSchema = {
    properties: {
        id: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Id'
        },
        uuid: {
            type: 'string',
            title: 'Uuid'
        },
        term: {
            type: 'string',
            title: 'Term'
        },
        region: {
            type: 'string',
            title: 'Region'
        },
        rank: {
            type: 'integer',
            title: 'Rank'
        },
        startDate: {
            type: 'string',
            format: 'date-time',
            title: 'Startdate'
        },
        trendType: {
            $ref: '#/components/schemas/TRENDS_TYPE'
        }
    },
    type: 'object',
    required: [
        'uuid',
        'term',
        'region',
        'rank',
        'startDate',
        'trendType'
    ],
    title: 'FirestoreTrend'
} as const;

export const FirestoreUserSchema = {
    properties: {
        id: {
            type: 'string',
            title: 'Id'
        },
        userId: {
            type: 'string',
            title: 'Userid'
        },
        email: {
            type: 'string',
            title: 'Email'
        },
        emailVerified: {
            type: 'boolean',
            title: 'Emailverified',
            default: false
        },
        givenName: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Givenname'
        },
        familyName: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Familyname'
        },
        organisation: {
            anyOf: [
                {
                    $ref: '#/components/schemas/FirestoreOrganisationReference'
                },
                {
                    type: 'null'
                }
            ]
        },
        apiKeys: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/FirestoreUserApiKey'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Apikeys',
            default: []
        },
        roles: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/UserRole'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Roles',
            default: []
        },
        deletedAt: {
            anyOf: [
                {
                    type: 'string',
                    format: 'date-time'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Deletedat'
        }
    },
    type: 'object',
    required: [
        'id',
        'userId',
        'email'
    ],
    title: 'FirestoreUser'
} as const;

export const FirestoreUserApiKeySchema = {
    properties: {
        identifier: {
            type: 'string',
            title: 'Identifier'
        },
        name: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Name'
        },
        apiKeyShort: {
            type: 'string',
            title: 'Apikeyshort'
        },
        createdAt: {
            type: 'string',
            format: 'date-time',
            title: 'Createdat'
        }
    },
    type: 'object',
    required: [
        'identifier',
        'apiKeyShort',
        'createdAt'
    ],
    title: 'FirestoreUserApiKey'
} as const;

export const FirestoreWeeklySearchTermSchema = {
    properties: {
        id: {
            type: 'string',
            title: 'Id'
        },
        term: {
            type: 'string',
            title: 'Term'
        },
        current_rank: {
            type: 'integer',
            title: 'Current Rank'
        },
        movements_indicator: {
            type: 'string',
            enum: [
                'up',
                'down',
                'no_change',
                'new'
            ],
            title: 'Movements Indicator'
        },
        movement_delta: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Movement Delta'
        },
        frequency_rank: {
            type: 'integer',
            title: 'Frequency Rank'
        }
    },
    type: 'object',
    required: [
        'id',
        'term',
        'current_rank',
        'movements_indicator',
        'frequency_rank'
    ],
    title: 'FirestoreWeeklySearchTerm'
} as const;

export const FirestoreWeeklySearchTermsDocSchema = {
    properties: {
        id: {
            type: 'string',
            title: 'Id'
        },
        market: {
            type: 'string',
            title: 'Market'
        },
        week: {
            type: 'string',
            title: 'Week'
        },
        previous_week: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Previous Week'
        },
        updated_at: {
            type: 'string',
            format: 'date-time',
            title: 'Updated At'
        },
        import_date: {
            type: 'string',
            format: 'date-time',
            title: 'Import Date'
        },
        terms: {
            items: {
                $ref: '#/components/schemas/FirestoreWeeklySearchTerm'
            },
            type: 'array',
            title: 'Terms'
        }
    },
    type: 'object',
    required: [
        'id',
        'market',
        'week',
        'updated_at',
        'import_date',
        'terms'
    ],
    title: 'FirestoreWeeklySearchTermsDoc'
} as const;

export const FixedDateRuleSchema = {
    properties: {
        type: {
            type: 'string',
            const: 'fixed_date',
            title: 'Type'
        },
        date_kind: {
            $ref: '#/components/schemas/SeasonalEventDateKind'
        },
        month: {
            type: 'integer',
            maximum: 12,
            minimum: 1,
            title: 'Month'
        },
        day: {
            type: 'integer',
            maximum: 31,
            minimum: 1,
            title: 'Day'
        }
    },
    additionalProperties: false,
    type: 'object',
    required: [
        'type',
        'date_kind',
        'month',
        'day'
    ],
    title: 'FixedDateRule'
} as const;

export const FixedSpanRuleSchema = {
    properties: {
        type: {
            type: 'string',
            const: 'fixed_span',
            title: 'Type'
        },
        date_kind: {
            $ref: '#/components/schemas/SeasonalEventDateKind'
        },
        start_month: {
            type: 'integer',
            maximum: 12,
            minimum: 1,
            title: 'Start Month'
        },
        start_day: {
            type: 'integer',
            maximum: 31,
            minimum: 1,
            title: 'Start Day'
        },
        end_month: {
            type: 'integer',
            maximum: 12,
            minimum: 1,
            title: 'End Month'
        },
        end_day: {
            type: 'integer',
            maximum: 31,
            minimum: 1,
            title: 'End Day'
        }
    },
    additionalProperties: false,
    type: 'object',
    required: [
        'type',
        'date_kind',
        'start_month',
        'start_day',
        'end_month',
        'end_day'
    ],
    title: 'FixedSpanRule'
} as const;

export const GenerationEventDataSchema = {
    properties: {
        kind: {
            $ref: '#/components/schemas/ContentKind'
        },
        count: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Count'
        }
    },
    type: 'object',
    required: [
        'kind'
    ],
    title: 'GenerationEventData',
    description: 'A single generation. Keyword, Thema and description generation run as\nseparate jobs, so each is its own event -- one `kind` per document. `count`\nis how many were produced, for the popover; it is None for descriptions,\nwhich always produce one.'
} as const;

export const GenerationMetadataEventSchema = {
    properties: {
        id: {
            type: 'string',
            title: 'Id'
        },
        productId: {
            type: 'string',
            title: 'Productid'
        },
        organisation: {
            $ref: '#/components/schemas/FirestoreOrganisationReference'
        },
        occurredAt: {
            type: 'string',
            format: 'date-time',
            title: 'Occurredat'
        },
        meta: {
            $ref: '#/components/schemas/MetadataEventMeta'
        },
        type: {
            type: 'string',
            const: 'GENERATION',
            title: 'Type',
            default: 'GENERATION'
        },
        generation: {
            $ref: '#/components/schemas/GenerationEventData'
        }
    },
    type: 'object',
    required: [
        'id',
        'productId',
        'organisation',
        'occurredAt',
        'generation'
    ],
    title: 'GenerationMetadataEvent'
} as const;

export const JsonValueSchema = {} as const;

export const ManuscriptProcessingErrorSchema = {
    properties: {
        code: {
            type: 'string',
            title: 'Code'
        },
        message: {
            type: 'string',
            title: 'Message'
        }
    },
    type: 'object',
    required: [
        'code',
        'message'
    ],
    title: 'ManuscriptProcessingError'
} as const;

export const ManuscriptProcessingStatusSchema = {
    type: 'string',
    enum: [
        'matched',
        'queued',
        'unmatched',
        'uploading',
        'processing',
        'complete',
        'error',
        'skipped_duplicate'
    ],
    title: 'ManuscriptProcessingStatus'
} as const;

export const MetadataEventMetaSchema = {
    properties: {
        importId: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Importid'
        },
        generationRequestId: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Generationrequestid'
        }
    },
    type: 'object',
    title: 'MetadataEventMeta',
    description: 'Links the event back to the source record it was emitted from.'
} as const;

export const NthWeekdayRuleSchema = {
    properties: {
        type: {
            type: 'string',
            const: 'nth_weekday',
            title: 'Type'
        },
        date_kind: {
            $ref: '#/components/schemas/SeasonalEventDateKind'
        },
        month: {
            type: 'integer',
            maximum: 12,
            minimum: 1,
            title: 'Month'
        },
        weekday: {
            $ref: '#/components/schemas/SeasonalEventWeekday'
        },
        ordinal: {
            type: 'integer',
            enum: [
                -1,
                1,
                2,
                3,
                4,
                5
            ],
            title: 'Ordinal'
        }
    },
    additionalProperties: false,
    type: 'object',
    required: [
        'type',
        'date_kind',
        'month',
        'weekday',
        'ordinal'
    ],
    title: 'NthWeekdayRule'
} as const;

export const OnixChunkReportingSchema = {
    properties: {
        id: {
            type: 'string',
            title: 'Id'
        },
        fileName: {
            type: 'string',
            title: 'Filename'
        },
        errors: {
            items: {
                type: 'string'
            },
            type: 'array',
            title: 'Errors',
            default: []
        },
        createdAt: {
            type: 'string',
            title: 'Createdat'
        },
        success: {
            items: {
                $ref: '#/components/schemas/OnixChunkReportingOperation'
            },
            type: 'array',
            title: 'Success',
            default: []
        },
        failed: {
            items: {
                $ref: '#/components/schemas/OnixChunkReportingOperation'
            },
            type: 'array',
            title: 'Failed',
            default: []
        },
        reportId: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Reportid',
            default: ''
        },
        isbn: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Isbn',
            default: ''
        },
        errorMessage: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Errormessage',
            default: ''
        },
        timestamp: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Timestamp',
            default: ''
        },
        productId: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Productid',
            default: ''
        },
        status: {
            anyOf: [
                {
                    $ref: '#/components/schemas/ChunkStatus'
                },
                {
                    type: 'null'
                }
            ]
        }
    },
    type: 'object',
    required: [
        'id',
        'fileName',
        'createdAt'
    ],
    title: 'OnixChunkReporting'
} as const;

export const OnixChunkReportingOperationSchema = {
    type: 'string',
    enum: [
        'ONIX_PARSING',
        'PRODUCT_INSERT'
    ],
    title: 'OnixChunkReportingOperation'
} as const;

export const OnixExportStatusSchema = {
    type: 'string',
    enum: [
        'REQUESTED',
        'PROCESSING',
        'COMPLETED',
        'ERROR'
    ],
    title: 'OnixExportStatus'
} as const;

export const OnixImportCountsSchema = {
    properties: {
        keywords: {
            type: 'integer',
            title: 'Keywords',
            default: 0
        },
        themaCodes: {
            type: 'integer',
            title: 'Themacodes',
            default: 0
        },
        descriptions: {
            type: 'integer',
            title: 'Descriptions',
            default: 0
        }
    },
    type: 'object',
    title: 'OnixImportCounts',
    description: 'Counts shown in the import marker\'s popover: subject schemes (keywords,\nThema categories) plus how many descriptions the ONIX record carried.'
} as const;

export const OnixImportEventDataSchema = {
    properties: {
        sourceFileName: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Sourcefilename'
        },
        changed: {
            items: {
                $ref: '#/components/schemas/ContentKind'
            },
            type: 'array',
            title: 'Changed'
        },
        counts: {
            $ref: '#/components/schemas/OnixImportCounts'
        },
        adoption: {
            items: {
                $ref: '#/components/schemas/AdoptionEntry'
            },
            type: 'array',
            title: 'Adoption'
        }
    },
    type: 'object',
    title: 'OnixImportEventData'
} as const;

export const OnixImportMetadataEventSchema = {
    properties: {
        id: {
            type: 'string',
            title: 'Id'
        },
        productId: {
            type: 'string',
            title: 'Productid'
        },
        organisation: {
            $ref: '#/components/schemas/FirestoreOrganisationReference'
        },
        occurredAt: {
            type: 'string',
            format: 'date-time',
            title: 'Occurredat'
        },
        meta: {
            $ref: '#/components/schemas/MetadataEventMeta'
        },
        type: {
            type: 'string',
            const: 'ONIX_IMPORT',
            title: 'Type',
            default: 'ONIX_IMPORT'
        },
        onixImport: {
            $ref: '#/components/schemas/OnixImportEventData'
        }
    },
    type: 'object',
    required: [
        'id',
        'productId',
        'organisation',
        'occurredAt',
        'onixImport'
    ],
    title: 'OnixImportMetadataEvent'
} as const;

export const OnixImportPipelineReportingSchema = {
    properties: {
        id: {
            type: 'string',
            title: 'Id'
        },
        bucketName: {
            type: 'string',
            title: 'Bucketname'
        },
        objectName: {
            type: 'string',
            title: 'Objectname'
        },
        fileName: {
            type: 'string',
            title: 'Filename'
        },
        createdAt: {
            type: 'string',
            title: 'Createdat'
        },
        folderName: {
            type: 'string',
            title: 'Foldername'
        },
        organisation: {
            $ref: '#/components/schemas/FirestoreOrganisationReference'
        },
        mode: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Mode'
        },
        status: {
            $ref: '#/components/schemas/PipelineImportReportStatus',
            default: 'processing'
        },
        totalFiles: {
            type: 'integer',
            title: 'Totalfiles',
            default: 0
        },
        filesCreatedFromSplitCount: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Filescreatedfromsplitcount'
        },
        filesUploadedCount: {
            anyOf: [
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Filesuploadedcount'
        },
        tasksScheduledSuccessfully: {
            type: 'integer',
            title: 'Tasksscheduledsuccessfully',
            default: 0
        },
        tasksScheduledFailed: {
            type: 'integer',
            title: 'Tasksscheduledfailed',
            default: 0
        },
        hasErrors: {
            type: 'boolean',
            title: 'Haserrors',
            default: false
        },
        errorCount: {
            type: 'integer',
            title: 'Errorcount',
            default: 0
        },
        lastError: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Lasterror'
        },
        lastUpdated: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Lastupdated'
        },
        completedAt: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Completedat'
        },
        productsSucceeded: {
            type: 'integer',
            title: 'Productssucceeded',
            default: 0
        },
        productsFailed: {
            type: 'integer',
            title: 'Productsfailed',
            default: 0
        },
        progress: {
            type: 'number',
            title: 'Progress',
            default: 0
        }
    },
    type: 'object',
    required: [
        'id',
        'bucketName',
        'objectName',
        'fileName',
        'createdAt',
        'folderName',
        'organisation'
    ],
    title: 'OnixImportPipelineReporting'
} as const;

export const OpenAIStatusSchema = {
    type: 'string',
    enum: [
        'VALIDATING',
        'FAILED',
        'IN_PROGRESS',
        'COMPLETED',
        'EXPIRED',
        'CANCELLED',
        'CANCELLING'
    ],
    title: 'OpenAIStatus'
} as const;

export const PRODUCT_AVAILABILITY_CODE_LITERALSchema = {
    type: 'string',
    enum: [
        '01',
        '09',
        '10',
        '11',
        '12',
        '20',
        '21',
        '22',
        '23',
        '30',
        '31',
        '32',
        '33',
        '34',
        '40',
        '41',
        '42',
        '43',
        '44',
        '45',
        '46',
        '47',
        '48',
        '49',
        '50',
        '51',
        '52',
        '97',
        '98',
        '99'
    ]
} as const;

export const PRODUCT_AVAILABILITY_NAME_LITERALSchema = {
    type: 'string',
    enum: [
        'Cancelled',
        'Not_yet_available_postponed_indefinitely',
        'Not_yet_available',
        'Awaiting_stock',
        'Not_yet_available_will_be_POD',
        'Available',
        'In_stock',
        'To_order',
        'POD',
        'Temporarily_unavailable',
        'Out_of_stock',
        'Reprinting',
        'Awaiting_reissue',
        'Temporarily_withdrawn_from_sale',
        'Not_available_reason_unspecified',
        'Not_available_replaced_by_new_product',
        'Not_available_other_format_available',
        'No_longer_supplied_by_the_supplier',
        'Apply_direct',
        'Not_sold_separately',
        'Withdrawn_from_sale',
        'Remaindered',
        'Not_available_replaced_by_POD',
        'Recalled',
        'Not_sold_as_set',
        'Not_available_publisher_indicates_OP',
        'Not_available_publisher_no_longer_sells_product_in_this_market',
        'No_recent_update_received',
        'No_longer_receiving_updates',
        'Contact_supplier'
    ]
} as const;

export const PRODUCT_FORM_CODE_LITERALSchema = {
    type: 'string',
    enum: [
        '00',
        'AA',
        'AB',
        'AC',
        'AD',
        'AE',
        'AF',
        'AG',
        'AH',
        'AI',
        'AJ',
        'AK',
        'AL',
        'AM',
        'AN',
        'AO',
        'AZ',
        'BA',
        'BB',
        'BC',
        'BD',
        'BE',
        'BF',
        'BG',
        'BH',
        'BI',
        'BJ',
        'BK',
        'BL',
        'BM',
        'BN',
        'BO',
        'BP',
        'BZ',
        'CA',
        'CB',
        'CC',
        'CD',
        'CE',
        'CZ',
        'DA',
        'DB',
        'DC',
        'DE',
        'DF',
        'DI',
        'DJ',
        'DK',
        'DL',
        'DM',
        'DN',
        'DO',
        'DZ',
        'EA',
        'EB',
        'EC',
        'ED',
        'FA',
        'FC',
        'FD',
        'FE',
        'FF',
        'FZ',
        'LA',
        'LB',
        'LC',
        'MA',
        'MB',
        'MC',
        'MZ',
        'PA',
        'PB',
        'PC',
        'PD',
        'PE',
        'PF',
        'PG',
        'PH',
        'PI',
        'PJ',
        'PK',
        'PL',
        'PM',
        'PN',
        'PO',
        'PP',
        'PQ',
        'PR',
        'PS',
        'PT',
        'PU',
        'PV',
        'PZ',
        'SA',
        'SB',
        'SC',
        'SD',
        'SE',
        'SF',
        'SG',
        'VA',
        'VF',
        'VI',
        'VJ',
        'VK',
        'VL',
        'VM',
        'VN',
        'VO',
        'VP',
        'VQ',
        'VZ',
        'XA',
        'XB',
        'XC',
        'XD',
        'XE',
        'XF',
        'XG',
        'XH',
        'XI',
        'XJ',
        'XK',
        'XL',
        'XM',
        'XN',
        'XO',
        'XY',
        'XZ',
        'ZA',
        'ZB',
        'ZC',
        'ZD',
        'ZE',
        'ZF',
        'ZG',
        'ZH',
        'ZI',
        'ZJ',
        'ZK',
        'ZL',
        'ZM',
        'ZN',
        'ZO',
        'ZP',
        'ZX',
        'ZY',
        'ZZ'
    ]
} as const;

export const PRODUCT_FORM_DESC_LITERALSchema = {
    type: 'string',
    enum: [
        'Undefined',
        'Audio',
        'Audio cassette',
        'CD-Audio',
        'DAT',
        'Audio disc',
        'Audio tape',
        'MiniDisc',
        'CD-Extra',
        'DVD Audio',
        'Downloadable audio file',
        'Pre-recorded digital audio player',
        'Pre-recorded SD card',
        'LP',
        'Downloadable and online audio file',
        'Online audio file',
        'Other audio format',
        'Book',
        'Hardback',
        'Paperback / softback',
        'Loose-leaf',
        'Spiral bound',
        'Pamphlet',
        'Leather / fine binding',
        'Board book',
        'Rag book',
        'Bath book',
        'Novelty book',
        'Slide bound',
        'Big book',
        'Part-work (fascículo)',
        'Fold-out book or chart',
        'Foam book',
        'Other book format',
        'Sheet map',
        'Sheet map, folded',
        'Sheet map, flat',
        'Sheet map, rolled',
        'Globe',
        'Other cartographic',
        'Digital (on physical carrier)',
        'CD-ROM',
        'CD-I',
        'Game cartridge',
        'Diskette',
        'DVD-ROM',
        'Secure Digital (SD) Memory Card',
        'Compact Flash Memory Card',
        'Memory Stick Memory Card',
        'USB Flash Drive',
        'Double-sided CD/DVD',
        'BR-ROM',
        'Other digital carrier',
        'Digital (delivered electronically)',
        'Digital download and online',
        'Digital online',
        'Digital download',
        'Film or transparency',
        'Slides',
        'OHP transparencies',
        'Filmstrip',
        'Film',
        'Other film or transparency format',
        'Digital product license',
        'Digital product license key',
        'Digital product license code',
        'Microform',
        'Microfiche',
        'Microfilm',
        'Other microform',
        'Miscellaneous print',
        'Address book',
        'Calendar',
        'Cards',
        'Copymasters',
        'Diary or journal',
        'Frieze',
        'Kit',
        'Sheet music',
        'Postcard book or pack',
        'Poster',
        'Record book',
        'Wallet or folder',
        'Pictures or photographs',
        'Wallchart',
        'Stickers',
        'Plate (lámina)',
        'Notebook / blank book',
        'Organizer',
        'Bookmark',
        'Leaflet',
        'Book plates',
        'Other printed item',
        'Multiple-component retail product',
        'Multiple-component retail product, boxed',
        'Multiple-component retail product, slip-cased',
        'Multiple-component retail product, shrink-wrapped',
        'Multiple-component retail product, loose',
        'Multiple-component retail product, part(s) enclosed',
        'Multiple-component retail product, entirely digital',
        'Video',
        'Videodisc',
        'DVD video',
        'VHS video',
        'Betamax video',
        'VCD',
        'SVCD',
        'HD DVD',
        'Blu-ray',
        'UMD Video',
        'CBHD',
        'Other video format',
        'Trade-only material',
        'Dumpbin – empty',
        'Dumpbin – filled',
        'Counterpack – empty',
        'Counterpack – filled',
        'Poster, promotional',
        'Shelf strip',
        'Window piece',
        'Streamer',
        'Spinner – empty',
        'Large book display',
        'Shrink-wrapped pack',
        'Boxed pack',
        'Pack (outer packaging unspecified)',
        'Spinner – filled',
        'Other point of sale – including retail product',
        'Other point of sale',
        'General merchandise',
        'Doll or figure',
        'Soft toy',
        'Toy',
        'Game',
        'T-shirt',
        'E-book reader',
        'Tablet computer',
        'Audiobook player',
        'Jigsaw',
        'Mug',
        'Tote bag',
        'Tableware',
        'Umbrella',
        'Paints, crayons, pencils',
        'Handicraft kit',
        'Other toy/game accessories',
        'Other apparel',
        'Other merchandise'
    ]
} as const;

export const PROJECT_TYPESchema = {
    type: 'string',
    enum: [
        'isbns',
        'google-trends',
        'amazon-trends'
    ],
    title: 'PROJECT_TYPE'
} as const;

export const PipelineImportReportSchema = {
    properties: {
        importId: {
            type: 'string',
            title: 'Importid'
        },
        bucketName: {
            type: 'string',
            title: 'Bucketname'
        },
        objectName: {
            type: 'string',
            title: 'Objectname'
        },
        fileName: {
            type: 'string',
            title: 'Filename'
        },
        createdAt: {
            type: 'string',
            title: 'Createdat'
        },
        folderName: {
            type: 'string',
            title: 'Foldername'
        },
        error: {
            anyOf: [
                {
                    $ref: '#/components/schemas/PipelineImportReportError'
                },
                {
                    type: 'null'
                }
            ]
        },
        errors: {
            items: {
                $ref: '#/components/schemas/PipelineImportReportError'
            },
            type: 'array',
            title: 'Errors',
            default: []
        },
        projectId: {
            type: 'string',
            title: 'Projectid'
        },
        completedAt: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Completedat'
        },
        globalIsbns: {
            items: {
                type: 'string'
            },
            type: 'array',
            title: 'Globalisbns',
            default: []
        },
        importedIsbns: {
            items: {
                type: 'string'
            },
            type: 'array',
            title: 'Importedisbns',
            default: []
        },
        filteredIsbns: {
            items: {
                type: 'string'
            },
            type: 'array',
            title: 'Filteredisbns',
            default: []
        },
        failedIsbns: {
            items: {
                type: 'string'
            },
            type: 'array',
            title: 'Failedisbns',
            default: []
        },
        productsGlobalCount: {
            type: 'integer',
            title: 'Productsglobalcount'
        },
        productsFilteredCount: {
            type: 'integer',
            title: 'Productsfilteredcount'
        },
        productsImportedCount: {
            type: 'integer',
            title: 'Productsimportedcount'
        },
        productsFailedCount: {
            type: 'integer',
            title: 'Productsfailedcount'
        },
        success: {
            type: 'boolean',
            title: 'Success'
        },
        description: {
            type: 'string',
            title: 'Description',
            default: ''
        },
        organisation: {
            $ref: '#/components/schemas/FirestoreOrganisationReference'
        }
    },
    type: 'object',
    required: [
        'importId',
        'bucketName',
        'objectName',
        'fileName',
        'createdAt',
        'folderName',
        'projectId',
        'productsGlobalCount',
        'productsFilteredCount',
        'productsImportedCount',
        'productsFailedCount',
        'success',
        'organisation'
    ],
    title: 'PipelineImportReport'
} as const;

export const PipelineImportReportErrorSchema = {
    properties: {
        level: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Level'
        },
        validator: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Validator'
        },
        location: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Location'
        },
        message: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Message'
        },
        error_type: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Error Type'
        }
    },
    type: 'object',
    title: 'PipelineImportReportError'
} as const;

export const PipelineImportReportStatusSchema = {
    type: 'string',
    enum: [
        'processing',
        'completed',
        'failed',
        'timeout'
    ],
    title: 'PipelineImportReportStatus'
} as const;

export const ProductRawSchema = {
    properties: {
        id: {
            type: 'string',
            title: 'Id'
        },
        header: {
            additionalProperties: true,
            type: 'object',
            title: 'Header'
        },
        baseProduct: {
            additionalProperties: true,
            type: 'object',
            title: 'Baseproduct'
        },
        rawOnixV3: {
            additionalProperties: true,
            type: 'object',
            title: 'Rawonixv3'
        }
    },
    type: 'object',
    required: [
        'id'
    ],
    title: 'ProductRaw',
    description: 'Raw projection of a productsImport document.\n\nThe three section dicts are 1:1 dumps of the corresponding subtrees on\n``FirestoreProductImport`` (``model_dump(by_alias=True, exclude_none=True)``).\nThe shape is intentionally not re-modeled here so the wire stays in sync\nwith what the import pipeline actually writes; consumers can rely on\nFirestore field names directly.'
} as const;

export const ProductSourceSchema = {
    type: 'string',
    enum: [
        'ONIX_IMPORT',
        'MANUSCRIPT_ONLY'
    ],
    title: 'ProductSource'
} as const;

export const SEARCH_TERMS_TYPESchema = {
    type: 'string',
    enum: [
        'AMAZON'
    ],
    title: 'SEARCH_TERMS_TYPE'
} as const;

export const SeasonalEventSchema = {
    properties: {
        event_id: {
            type: 'string',
            minLength: 1,
            pattern: '^[a-z0-9]+(?:-[a-z0-9]+)*$',
            title: 'Event Id'
        },
        display_name: {
            type: 'string',
            minLength: 1,
            title: 'Display Name'
        },
        region: {
            $ref: '#/components/schemas/SeasonalEventRegion'
        },
        lead_time_months: {
            type: 'integer',
            maximum: 12,
            minimum: 0,
            title: 'Lead Time Months'
        },
        date_rule: {
            anyOf: [
                {
                    oneOf: [
                        {
                            $ref: '#/components/schemas/FixedDateRule'
                        },
                        {
                            $ref: '#/components/schemas/NthWeekdayRule'
                        },
                        {
                            $ref: '#/components/schemas/EasterOffsetRule'
                        },
                        {
                            $ref: '#/components/schemas/FixedSpanRule'
                        }
                    ],
                    discriminator: {
                        propertyName: 'type',
                        mapping: {
                            easter_offset: '#/components/schemas/EasterOffsetRule',
                            fixed_date: '#/components/schemas/FixedDateRule',
                            fixed_span: '#/components/schemas/FixedSpanRule',
                            nth_weekday: '#/components/schemas/NthWeekdayRule'
                        }
                    }
                },
                {
                    type: 'null'
                }
            ],
            title: 'Date Rule'
        },
        occurrences: {
            items: {
                $ref: '#/components/schemas/SeasonalEventOccurrence'
            },
            type: 'array',
            title: 'Occurrences'
        },
        overrides: {
            items: {
                $ref: '#/components/schemas/SeasonalEventOverride'
            },
            type: 'array',
            title: 'Overrides'
        },
        prompts: {
            items: {
                $ref: '#/components/schemas/SeasonalEventPrompt'
            },
            type: 'array',
            title: 'Prompts'
        },
        provenance: {
            anyOf: [
                {
                    $ref: '#/components/schemas/SeasonalEventProvenance'
                },
                {
                    type: 'null'
                }
            ]
        },
        categories: {
            items: {
                type: 'string'
            },
            type: 'array',
            title: 'Categories'
        },
        evidence: {
            items: {
                type: 'string'
            },
            type: 'array',
            title: 'Evidence'
        },
        judge_reasoning: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Judge Reasoning'
        }
    },
    additionalProperties: false,
    type: 'object',
    required: [
        'event_id',
        'display_name',
        'region',
        'lead_time_months',
        'date_rule'
    ],
    title: 'SeasonalEvent'
} as const;

export const SeasonalEventDateKindSchema = {
    type: 'string',
    enum: [
        'actual',
        'observed',
        'campaign'
    ],
    title: 'SeasonalEventDateKind'
} as const;

export const SeasonalEventDateSourceSchema = {
    properties: {
        type: {
            type: 'string',
            enum: [
                'generated',
                'curated'
            ],
            title: 'Type'
        },
        reference: {
            type: 'string',
            minLength: 1,
            title: 'Reference'
        },
        url: {
            anyOf: [
                {
                    type: 'string',
                    minLength: 1,
                    format: 'uri'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Url'
        },
        checked_at: {
            anyOf: [
                {
                    type: 'string',
                    format: 'date'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Checked At'
        }
    },
    additionalProperties: false,
    type: 'object',
    required: [
        'type',
        'reference'
    ],
    title: 'SeasonalEventDateSource'
} as const;

export const SeasonalEventOccurrenceSchema = {
    properties: {
        year: {
            type: 'integer',
            minimum: 1,
            title: 'Year'
        },
        date_kind: {
            $ref: '#/components/schemas/SeasonalEventDateKind'
        },
        start: {
            type: 'string',
            format: 'date',
            title: 'Start'
        },
        end: {
            type: 'string',
            format: 'date',
            title: 'End'
        },
        source: {
            $ref: '#/components/schemas/SeasonalEventDateSource'
        }
    },
    additionalProperties: false,
    type: 'object',
    required: [
        'year',
        'date_kind',
        'start',
        'end',
        'source'
    ],
    title: 'SeasonalEventOccurrence'
} as const;

export const SeasonalEventOverrideSchema = {
    properties: {
        year: {
            type: 'integer',
            minimum: 1,
            title: 'Year'
        },
        date_kind: {
            $ref: '#/components/schemas/SeasonalEventDateKind'
        },
        action: {
            type: 'string',
            enum: [
                'replace',
                'suppress'
            ],
            title: 'Action'
        },
        start: {
            anyOf: [
                {
                    type: 'string',
                    format: 'date'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Start'
        },
        end: {
            anyOf: [
                {
                    type: 'string',
                    format: 'date'
                },
                {
                    type: 'null'
                }
            ],
            title: 'End'
        },
        source: {
            $ref: '#/components/schemas/SeasonalEventDateSource'
        }
    },
    additionalProperties: false,
    type: 'object',
    required: [
        'year',
        'date_kind',
        'action',
        'source'
    ],
    title: 'SeasonalEventOverride'
} as const;

export const SeasonalEventPromptSchema = {
    properties: {
        prompt_id: {
            type: 'string',
            minLength: 1,
            pattern: '^[a-z0-9]+(?:-[a-z0-9]+)*$',
            title: 'Prompt Id'
        },
        prompt_revision: {
            type: 'integer',
            minimum: 1,
            title: 'Prompt Revision'
        },
        text: {
            type: 'string',
            minLength: 1,
            title: 'Text'
        },
        provenance: {
            anyOf: [
                {
                    $ref: '#/components/schemas/SeasonalEventProvenance'
                },
                {
                    type: 'null'
                }
            ]
        }
    },
    additionalProperties: false,
    type: 'object',
    required: [
        'prompt_id',
        'prompt_revision',
        'text'
    ],
    title: 'SeasonalEventPrompt'
} as const;

export const SeasonalEventProvenanceSchema = {
    properties: {
        pipeline_version: {
            type: 'string',
            minLength: 1,
            title: 'Pipeline Version'
        },
        template_version: {
            type: 'string',
            minLength: 1,
            title: 'Template Version'
        },
        model: {
            type: 'string',
            minLength: 1,
            title: 'Model'
        },
        parameters: {
            additionalProperties: {
                $ref: '#/components/schemas/JsonValue'
            },
            type: 'object',
            title: 'Parameters'
        },
        inputs: {
            additionalProperties: {
                $ref: '#/components/schemas/JsonValue'
            },
            type: 'object',
            title: 'Inputs'
        },
        generated_at: {
            type: 'string',
            format: 'date-time',
            title: 'Generated At'
        },
        langfuse_trace_id: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Langfuse Trace Id'
        }
    },
    additionalProperties: false,
    type: 'object',
    required: [
        'pipeline_version',
        'template_version',
        'model',
        'parameters',
        'inputs',
        'generated_at'
    ],
    title: 'SeasonalEventProvenance'
} as const;

export const SeasonalEventRegionSchema = {
    type: 'string',
    enum: [
        'us',
        'uk',
        'de',
        'aus',
        'international'
    ],
    title: 'SeasonalEventRegion'
} as const;

export const SeasonalEventWeekdaySchema = {
    type: 'string',
    enum: [
        'monday',
        'tuesday',
        'wednesday',
        'thursday',
        'friday',
        'saturday',
        'sunday'
    ],
    title: 'SeasonalEventWeekday'
} as const;

export const SemanticDataCharacterSchema = {
    properties: {
        name: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Name'
        },
        age: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'integer'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Age'
        },
        pronouns: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Pronouns'
        },
        role: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Role'
        },
        description: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Description'
        },
        aliases: {
            anyOf: [
                {
                    items: {
                        type: 'string'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Aliases'
        }
    },
    type: 'object',
    title: 'SemanticDataCharacter'
} as const;

export const SemanticDataMetadataSchema = {
    properties: {
        title: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Title'
        },
        author: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Author'
        },
        language: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Language'
        }
    },
    type: 'object',
    title: 'SemanticDataMetadata'
} as const;

export const SemanticDataWorldSettingSchema = {
    properties: {
        settingType: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Settingtype'
        },
        location: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Location'
        },
        timePeriod: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Timeperiod'
        },
        locationLabel: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Locationlabel'
        },
        timePeriodLabel: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Timeperiodlabel'
        },
        localSocialStructure: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Localsocialstructure'
        }
    },
    type: 'object',
    title: 'SemanticDataWorldSetting'
} as const;

export const SemanticDataWorldSettingsSchema = {
    properties: {
        settings: {
            anyOf: [
                {
                    items: {
                        $ref: '#/components/schemas/SemanticDataWorldSetting'
                    },
                    type: 'array'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Settings'
        },
        socialStructure: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Socialstructure'
        },
        metaphysics: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Metaphysics'
        },
        socialStructureLabel: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Socialstructurelabel'
        },
        metaphysicsLabel: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Metaphysicslabel'
        }
    },
    type: 'object',
    title: 'SemanticDataWorldSettings'
} as const;

export const SeriesLevelSchema = {
    type: 'string',
    enum: [
        'collection',
        'subcollection'
    ],
    title: 'SeriesLevel'
} as const;

export const SeriesNumberSourceSchema = {
    type: 'string',
    enum: [
        'collection_sequence',
        'part_number'
    ],
    title: 'SeriesNumberSource'
} as const;

export const SeriesOrderTypeSchema = {
    type: 'string',
    enum: [
        'proprietary',
        'title_order',
        'publication_order',
        'temporal_narrative_order',
        'original_publication_order',
        'suggested_reading_order',
        'suggested_display_order'
    ],
    title: 'SeriesOrderType',
    description: 'ONIX List 197 (collection sequence type).'
} as const;

export const SeriesStatusSchema = {
    type: 'string',
    enum: [
        'in_series',
        'not_in_series',
        'unknown'
    ],
    title: 'SeriesStatus'
} as const;

export const SharedDataSchema = {
    properties: {
        defaultTargetGroups: {
            items: {
                type: 'string'
            },
            type: 'array',
            title: 'Defaulttargetgroups',
            examples: [
                [
                    'Young Adults',
                    'New Adults',
                    'Children Board Books',
                    'Children Picture Books',
                    'Children Early Readers',
                    'Children Chapter Books',
                    'Children Middle Grade',
                    'Technical Academic'
                ]
            ]
        },
        ProductAvailability: {
            additionalProperties: {
                type: 'string'
            },
            type: 'object',
            title: 'Productavailability',
            examples: [
                {
                    Apply_direct: '44',
                    Available: '20',
                    Awaiting_reissue: '33',
                    Awaiting_stock: '11',
                    Cancelled: '01',
                    Contact_supplier: '99',
                    In_stock: '21',
                    No_longer_receiving_updates: '98',
                    No_longer_supplied_by_the_supplier: '43',
                    No_recent_update_received: '97',
                    Not_available_other_format_available: '42',
                    Not_available_publisher_indicates_OP: '51',
                    Not_available_publisher_no_longer_sells_product_in_this_market: '52',
                    Not_available_reason_unspecified: '40',
                    Not_available_replaced_by_POD: '48',
                    Not_available_replaced_by_new_product: '41',
                    Not_sold_as_set: '50',
                    Not_sold_separately: '45',
                    Not_yet_available: '10',
                    Not_yet_available_postponed_indefinitely: '09',
                    Not_yet_available_will_be_POD: '12',
                    Out_of_stock: '31',
                    POD: '23',
                    Recalled: '49',
                    Remaindered: '47',
                    Reprinting: '32',
                    Temporarily_unavailable: '30',
                    Temporarily_withdrawn_from_sale: '34',
                    To_order: '22',
                    Withdrawn_from_sale: '46'
                }
            ]
        },
        themaMajorSubjectCodes: {
            items: {
                type: 'string'
            },
            type: 'array',
            title: 'Themamajorsubjectcodes',
            description: 'List of major THEMA subject category codes',
            examples: [
                [
                    'A',
                    'C',
                    'D',
                    'F',
                    'G',
                    'J',
                    'K',
                    'L',
                    'M',
                    'N',
                    'P',
                    'Q',
                    'R',
                    'S',
                    'T',
                    'U',
                    'V',
                    'W',
                    'X',
                    'Y'
                ]
            ]
        },
        themaMajorQualifierCodes: {
            items: {
                type: 'string'
            },
            type: 'array',
            title: 'Themamajorqualifiercodes',
            description: 'List of major THEMA qualifier category codes',
            examples: [
                [
                    '1',
                    '2',
                    '3',
                    '4',
                    '5',
                    '6'
                ]
            ]
        }
    },
    type: 'object',
    title: 'SharedData'
} as const;

export const SubjectSourceSchema = {
    type: 'string',
    enum: [
        'GENERATED',
        'DATABASE',
        'MANUAL'
    ],
    title: 'SubjectSource'
} as const;

export const TRENDS_TYPESchema = {
    type: 'string',
    enum: [
        'GOOGLE',
        'AMAZON'
    ],
    title: 'TRENDS_TYPE'
} as const;

export const UserRoleSchema = {
    type: 'string',
    enum: [
        'SUPER_ADMIN',
        'ADMIN',
        'MEMBER'
    ],
    title: 'UserRole'
} as const;
